webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(479)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(761),
  /* scopeId */
  "data-v-1a1be74e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);




/* harmony default export */ __webpack_exports__["a"] = ({
  passAvator: function passAvator(params) {
    return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/wedu/v1/sign-in/update-profile', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  notice: function notice(params) {
    return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/wedu/v1/notice/index?', {
      params: params
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  completeCourse: function completeCourse(pageNumber) {
    return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/api/studentAboveCourse?pageNumber=' + pageNumber).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  detailCourse: function detailCourse(id) {
    return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/api/detailedInformation?sigId=' + id).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  courseAbout: function courseAbout(params) {
    return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/wedu/v1/course-order-item/index', {
      params: params
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        console.log(response);
        return response.data;
      }
    });
  },
  photos: function photos(page) {
    return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/wedu/v1/course/my-photos', {
      params: { page: page }
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  exit: function exit(params) {
    return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].get('/wedu/v1/sign-in/logout').then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  uploadCid: function uploadCid(params) {
    return __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].post('/wedu/v1/sign-in/user-profile', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);




/* harmony default export */ __webpack_exports__["a"] = ({
  getAllSchools: function getAllSchools() {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/api/campusList').then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  getAllClass: function getAllClass(id) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/api/list?campusId=' + id).then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  getAllQueryTheSignInStatus: function getAllQueryTheSignInStatus(schoolId, gradeId) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/api/queryTheSignInStatus').then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  getAllSignInStudents: function getAllSignInStudents(list) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/api/signInList?campusId=' + list.campusId + '&classId=' + list.classId + '&lessons=' + list.lessons).then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  createSignIn: function createSignIn(list) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].post('/api/signIn', { studentList: list }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  getStudents: function getStudents(schoolId, gradeId, page) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/api/rosterList', {
      params: { campusId: schoolId, classId: gradeId, pageNumber: page }
    }).then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  getStudentProfileInfo: function getStudentProfileInfo(params) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/api/studentInformation', {
      params: params
    }).then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  getAttendanceList: function getAttendanceList(params) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/wedu/v1/course/sign-in-record', {
      params: params
    }).then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  getTeacherProfileInfo: function getTeacherProfileInfo() {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/wedu/v1/config/working-state').then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  }
});

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  "data-v-6e391144",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(162);








var baseUrl =  true ? __WEBPACK_IMPORTED_MODULE_2__config___default.a.build.baseUrl : config.dev.baseUrl + ':' + config.dev.port + '/';
var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: baseUrl,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json'
  },
  withCredentials: false,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status <= 299;
  }
});
var isexpiredShown = false;

instance.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.userInfo.user) {
    config.headers['token'] = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.userInfo.user.token;
  }
  return config;
}, function (error) {
  console.log(error);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

instance.interceptors.response.use(function (response) {
  if (response.status == 200) {
    isexpiredShown = false;
  }
  return response;
}, function (error) {
  if (error.response.status === 401) {
    if (!isexpiredShown) {
      isexpiredShown = true;
      __WEBPACK_IMPORTED_MODULE_4_mint_ui__["MessageBox"].confirm(error.response.data.msg, '提示', {
        showCancelButton: false,
        closeOnClickModal: false,
        confirmButtonText: '确认',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('clearUserInfo');
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('clearLoginInfo');
        __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ path: '/login' });
      });
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_users__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_passValue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_pictureview__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_teacherschools__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_photos_js__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_SelectSignature__ = __webpack_require__(349);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    userInfo: __WEBPACK_IMPORTED_MODULE_2__modules_users__["a" /* default */],
    passValue: __WEBPACK_IMPORTED_MODULE_3__modules_passValue__["a" /* default */],
    pictureView: __WEBPACK_IMPORTED_MODULE_4__modules_pictureview__["a" /* default */],
    teacherschools: __WEBPACK_IMPORTED_MODULE_5__modules_teacherschools__["a" /* default */],
    SelectSignature: __WEBPACK_IMPORTED_MODULE_7__modules_SelectSignature__["a" /* default */],
    photos: __WEBPACK_IMPORTED_MODULE_6__modules_photos_js__["a" /* default */]
  }
}));

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(779),
  /* scopeId */
  "data-v-57fd6397",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(489)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(771),
  /* scopeId */
  "data-v-3eeb08d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */,
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_js__ = __webpack_require__(34);



/* harmony default export */ __webpack_exports__["a"] = ({
  getSignatureList: function getSignatureList(dateValue) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/api/classAttendance', {
      params: {
        signTime: dateValue
      }
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  getSignatureImage: function getSignatureImage(list) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/api/image?id=' + list.id + '&status=' + list.status + '&signStatus=' + list.signStatus + '&createTime=' + list.createTimes).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  SubmitSignatureImage: function SubmitSignatureImage(fileData) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].post('/api/signaturePicture', fileData).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  getCustomSignatureImage: function getCustomSignatureImage() {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/api/customPicture').then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  SubmitCustomSignatureImage: function SubmitCustomSignatureImage(fileData) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].post('/api/customSignature', fileData).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  }
});

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Login__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_ParentMain__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_ParentMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_ParentMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageTransition__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PageTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_MyClass__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_MyClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_MyClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_MyRecord__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_MyRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_MyRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Myrecord_MyNew__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Myrecord_MyNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Myrecord_MyNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Myrecord_TecComment__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Myrecord_TecComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Myrecord_TecComment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Myrecord_AboutCourse__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Myrecord_AboutCourse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Myrecord_AboutCourse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Myrecord_CompletedCourse__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Myrecord_CompletedCourse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_Myrecord_CompletedCourse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Myrecord_MyPhoto__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Myrecord_MyPhoto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_Myrecord_MyPhoto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_setting__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_aboutUs__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_aboutUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_aboutUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Myrecord_courseDetail__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Myrecord_courseDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_Myrecord_courseDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_PictureView__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_PictureView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_PictureView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_TeacherMain__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_TeacherMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_TeacherMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Work__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_Work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_TeacherInfo__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_TeacherInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_TeacherInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_StudentCheckIn__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_StudentCheckIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_StudentCheckIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_StudentList__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_StudentList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_StudentList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_StudentProfileInfo__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_StudentProfileInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_StudentProfileInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Attendance__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Attendance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_Attendance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_Loading__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_signature__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_signature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__views_signature__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_UpImage__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_UpImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__views_UpImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__localstorage_localStorage__ = __webpack_require__(171);































__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.goBack = function () {
  this.isBack = true;
  window.history.go(-1);
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_5__components_PageTransition___default.a,
    children: [{
      path: '',
      name: 'Loading',
      component: __WEBPACK_IMPORTED_MODULE_24__views_Loading___default.a
    }, {
      path: '/login',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_2__views_Login___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.userInfo.user) {
          if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.userInfo.user.roleId === 7) {
            next({ path: '/parent-main' });
          } else {
            next({ path: '/teacher-main' });
          }
        } else {
          next();
        }
      }
    }, {
      path: '/parent-main',
      name: 'parent-main',
      component: __WEBPACK_IMPORTED_MODULE_3__views_ParentMain___default.a,
      redirect: '/class',
      children: [{
        name: 'myClass',
        path: '/class',
        component: __WEBPACK_IMPORTED_MODULE_6__views_MyClass___default.a,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/record',
        component: __WEBPACK_IMPORTED_MODULE_7__views_MyRecord___default.a,
        meta: {
          requireAuth: true
        }
      }],
      meta: {
        requireAuth: true
      }
    }, {
      path: '/signature/:id/:signStatus/:isCustom',
      name: 'signature',
      component: __WEBPACK_IMPORTED_MODULE_25__views_signature___default.a,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/record-new',
      name: 'record-new',
      component: __WEBPACK_IMPORTED_MODULE_8__views_Myrecord_MyNew___default.a,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/record-TecComment',
      name: 'record-TecComment',
      component: __WEBPACK_IMPORTED_MODULE_9__views_Myrecord_TecComment___default.a,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/record-aboutCourse',
      name: 'record-aboutCourse',
      component: __WEBPACK_IMPORTED_MODULE_10__views_Myrecord_AboutCourse___default.a,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/record-completedCourse',
      name: 'record-completedCourse',
      component: __WEBPACK_IMPORTED_MODULE_11__views_Myrecord_CompletedCourse___default.a
    }, {
      path: '/record-completedCourse-detail',
      name: 'record-completedCourse-detail',
      component: __WEBPACK_IMPORTED_MODULE_15__views_Myrecord_courseDetail___default.a
    }, {
      path: '/record-photo',
      name: 'record-photo',
      component: __WEBPACK_IMPORTED_MODULE_12__views_Myrecord_MyPhoto___default.a
    }, {
      path: '/record/setting',
      name: '/record/setting',
      component: __WEBPACK_IMPORTED_MODULE_13__views_setting___default.a
    }, {
      path: '/aboutUs',
      name: '/aboutUs',
      component: __WEBPACK_IMPORTED_MODULE_14__views_aboutUs___default.a
    }, {
      path: '/picture-view',
      name: '/pictureView',
      component: __WEBPACK_IMPORTED_MODULE_16__views_PictureView___default.a
    }, {
      path: '/teacher-main',
      name: '/teacherMain',
      component: __WEBPACK_IMPORTED_MODULE_17__views_TeacherMain___default.a,
      redirect: '/work',
      children: [{
        path: '/work',
        name: 'work',
        component: __WEBPACK_IMPORTED_MODULE_18__views_Work___default.a
      }, {
        path: '/my-class',
        name: 'my-class',
        component: __WEBPACK_IMPORTED_MODULE_6__views_MyClass___default.a
      }, {
        path: '/teacher-info',
        name: 'teacher-info',
        component: __WEBPACK_IMPORTED_MODULE_19__views_TeacherInfo___default.a
      }]
    }, {
      path: '/UpImage',
      name: 'UpImage',
      component: __WEBPACK_IMPORTED_MODULE_26__views_UpImage___default.a
    }, {
      path: '/student-check-in',
      name: 'studentCheckIn',
      component: __WEBPACK_IMPORTED_MODULE_20__views_StudentCheckIn___default.a
    }, {
      path: '/attendance',
      name: 'attendance',
      component: __WEBPACK_IMPORTED_MODULE_23__views_Attendance___default.a
    }, {
      path: '/student-list',
      name: 'studentList',
      component: __WEBPACK_IMPORTED_MODULE_21__views_StudentList___default.a
    }, {
      path: '/student-profile',
      name: 'studentProfileInfo',
      component: __WEBPACK_IMPORTED_MODULE_22__views_StudentProfileInfo___default.a
    }]
  }],
  linkActiveClass: ['u-link--Active1', 'u-link--Active2', 'u-link--Active3']
});

router.beforeEach(function (to, from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_27__localstorage_localStorage__["a" /* default */].getData('token');
  if (!token) {
    if (to.path !== '/login') {
      next({ path: '/login' });
    }
  }
  next();
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(687);

module.exports = {
  build: {
    env: __webpack_require__(165),//指定构建环境，可以根据需要设置不同的环境变量、API 地址等。
    index: path.resolve(__dirname, '../dist/index.html'),//指定构建环境，可以根据需要设置不同的环境变量、API 地址等。
    assetsRoot: path.resolve(__dirname, '../dist'),//指定构建后的静态文件的根目录路径。
    assetsSubDirectory: 'static',//指定构建后的静态文件的根目录路径。
    assetsPublicPath: '/',  // 编译发布的根目录，可配置为资源服务器域名或 CDN 域名
    productionSourceMap: true,//指定是否生成生产环境的源映射文件。
    productionGzip: false,//指定是否启用 gzip 压缩。
    productionGzipExtensions: ['js', 'css'],//指定需要进行 gzip 压缩的文件扩展名。
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report,// 指定是否生成构建报告，可以通过命令行参数来控制。
    //baseUrl: 'https://42.123.90.98:8080'
    baseUrl: 'https://wakooedu.cn'// 指定是否生成构建报告，可以通过命令行参数来控制。
    //baseUrl:'https://localhost'
  },
  dev: {
    env: __webpack_require__(325),// 指定构建环境，可以根据需要设置不同的环境变量、API 地址等。
    port: 80,//指定开发服务器的端口号
    // port:8080,
    autoOpenBrowser: true,//是否在构建完成后自动打开浏览器
    assetsSubDirectory: 'static',//指定开发环境下静态资源的输出子目录。
    assetsPublicPath: '/',//指定开发环境下静态资源的引用路径。
    proxyTable: {//指定开发环境下静态资源的引用路径。
      //  少帅 本地  代理配置
      // '/repositories/yii2-starter-kit/frontend/web/wedu/v1': {
      //   target: 'http://192.168.5.108',
      //   changeOrigin: true
      // },
      // 测试服务器代理配置
      '/api': {
        target: 'http://192.168.0.114',
        changeOrigin: true,
        pathRewrite: {
          '^/api': ''
        }
      }
    },
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false, //是否生成 CSS 的源映射文件
    // baseUrl: 'http://localhost'
    baseUrl: 'http://192.168.0.114' //指定 API 的基础 URL 地址。
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ({
  addData: function addData(name, data) {
    if (!data) return false;
    var datas = '';
    if (data instanceof Object) {
      datas = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
    } else {
      datas = data;
    }
    window.localStorage[name] = datas;
  },
  getData: function getData(name) {
    var data = window.localStorage[name];
    if (data) {
      return data;
    } else {
      return false;
    }
  },
  removeData: function removeData(name) {
    window.localStorage.removeItem(name);
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return list; });
/* harmony export (immutable) */ __webpack_exports__["b"] = studentImageList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);




var list = [];
function studentImageList(imageList) {
  if (imageList != '') {
    var existingObj = list.find(function (obj) {
      return obj.id === imageList.id;
    });

    if (existingObj) {
      var index = list.findIndex(function (obj) {
        return obj.id === imageList.id;
      });

      imageList.imgList.forEach(function (item) {
        list[index].imgList.push(item);
      });

      var uniqueArray = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(list[index].imgList)));

      list[index].imgList = uniqueArray;
    } else {
      list.push(imageList);
    }
  } else {
    return list.length = 0;
  }
}

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(484)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(766),
  /* scopeId */
  "data-v-2bad1b60",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  "data-v-7c7db7c3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(491)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  "data-v-3fd3b443",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(490)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(772),
  /* scopeId */
  "data-v-3f3c471e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(495)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  "data-v-4b6b4b8b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  resize: function resize(doc, win) {
    var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function recalc() {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;

      docEl.style.fontSize = clientWidth / 10 + 'px';
    };
    recalc();
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
  }
});

/***/ }),
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(795),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(801)
var prodEnv = __webpack_require__(165)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);




/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(username, password) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].post('/jwt/login', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
      'username': username,
      'password': password
    })).then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回失败');
      }
    });
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);




/* unused harmony default export */ var _unused_webpack_default_export = ({
  getUpToken: function getUpToken() {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('wedu/v1/sign-in/qiniu-token').then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  postImg: function postImg(params) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].post('wedu/v1/share-stream/create', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  deleteImgFromQiniu: function deleteImgFromQiniu(params) {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].post('wedu/v1/share-stream/qiniu-delete', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (response) {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_js__ = __webpack_require__(34);




/* unused harmony default export */ var _unused_webpack_default_export = ({
  Record: function Record() {
    return __WEBPACK_IMPORTED_MODULE_0__axios_js__["a" /* default */].get('/wedu/v1/config/account').then(function (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回失败');
      }
    }).catch(function (error) {
      throw new Error(error);
    });
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dialog__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_image_css__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_image_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_image_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_image__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_style_css__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_scss_index_scss__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_scss_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_scss_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_v_tap__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_v_tap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_v_tap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__App__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_base_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_esign__ = __webpack_require__(323);




































__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vue_esign__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_15_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_image___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_image___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a);

__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_mint_ui___default.a);
__WEBPACK_IMPORTED_MODULE_23__components_base_js__["a" /* default */].resize(document, window);
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_15_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_v_tap___default.a);

__WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.requireAuth) {
    if (__WEBPACK_IMPORTED_MODULE_20__store__["a" /* default */].state.userInfo.user) {
      next();
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});

new __WEBPACK_IMPORTED_MODULE_15_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_20__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_22__App___default.a }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  SelectSignature: {},
  CustomSignatureId: ''
};
var getters = {
  SelectSignature: function SelectSignature(state) {
    return state.SelectSignature;
  }
};
var mutations = {
  SelectSignature: function SelectSignature(state, value) {
    state.SelectSignature = value;
  },
  CustomSignature: function CustomSignature(state, value) {
    state.CustomSignatureId = value;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  state: {
    id: 0
  }
};
var getters = {
  getPassID: function getPassID(state) {
    return state.id;
  }
};
var mutations = {
  passValue: function passValue(state, payload) {
    state.id = payload.id;
    console.log(state.id);
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_netTool__ = __webpack_require__(25);



var state = {
  photos: [],
  page: 0,
  pageCount: 0,
  disable: false,
  scrollTop: 0,
  loadingState: 1 };

var getters = {
  photosInfo: function photosInfo(state) {
    return state;
  },
  loadingText: function loadingText(state) {
    var text = '';
    switch (state.loadingState) {
      case 1:
        text = '';
        break;
      case 2:
        text = '加载中...';
        break;
      case 3:
        text = '没有更多内容';
        break;
      case 4:
        text = '您还没有照片';
        break;
      case 5:
        text = '请检查您的网络';
        break;
    }
    return text;
  }
};

var mutations = {
  clearPhotosInfo: function clearPhotosInfo(state) {
    state.photos = [];
    state.page = 0;
    state.scrollTop = 0;
    state.pageCount = 0;
    state.disable = false;
    state.loadingState = 1;
  },
  setScrollTop: function setScrollTop(state, top) {
    state.scrollTop = top;
  },
  setPhotos: function setPhotos(state, _ref) {
    var photos = _ref.photos;

    state.photos = photos;
  },
  addPhotos: function addPhotos(state, _ref2) {
    var photos = _ref2.photos;

    state.photos = state.photos.concat(photos);
  },
  setPage: function setPage(state, page) {
    state.page = page;
  },
  pageAdd: function pageAdd(state) {
    state.page++;
  },
  setPageCount: function setPageCount(state, pageCount) {
    state.pageCount = pageCount;
  },
  setDisable: function setDisable(state, disable) {
    state.disable = disable;
  },
  setLoadingState: function setLoadingState(state, status) {
    state.loadingState = status;
  }
};

var actions = {
  getPhotos: function getPhotos(_ref3, payload) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit('pageAdd');
    commit('setDisable', true);
    __WEBPACK_IMPORTED_MODULE_0__api_netTool__["a" /* default */].photos(state.page).then(function (response) {
      if (response.errno === '0') {
        if (state.page === 1) {
          commit('setPhotos', { photos: response.result });
        } else {
          commit('addPhotos', { photos: response.result });
        }
        commit('setPage', response._meta.currentPage);
        commit('setPageCount', response._meta.pageCount);
        commit('setDisable', state.page >= state.pageCount);
        if (state.disable) {
          if (state.photos.length === 0) {
            commit('setLoadingState', 4);
          } else {
            commit('setLoadingState', 3);
          }
        } else {
          commit('setLoadingState', 1);
        }
      } else {
        payload.toastInfo(response.message);
      }
    }).catch(function (e) {
      console.log(e);
      commit('setLoadingState', 5);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  imgs: [],
  index: 0
};

var mutations = {
  clearImgInfo: function clearImgInfo(state) {
    state.imgs = [];
    state.index = 0;
  },
  setImgInfo: function setImgInfo(state, payload) {
    state.imgs = payload.imgs;
    state.index = payload.index;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_teacher__ = __webpack_require__(26);


var state = {
  schools: [],
  school: {
    id: '',
    campusName: '选择学校'
  },
  grade: {
    id: '',
    gradeName: '选择班级'
  },
  grades: [],
  listStudents: [],
  index: '',
  selectedCourse: '',
  studentList: {} };

var getters = {
  schools: function schools(state) {
    return state.schools;
  },
  school: function school(state) {
    return state.school;
  },
  grade: function grade(state) {
    return state.grade;
  },
  grades: function grades(state) {
    return state.grades;
  },
  studentList: function studentList(state) {
    return state.listStudents;
  },
  selectedCourse: function selectedCourse(state) {
    return state.selectedCourse;
  }
};
var actions = {
  getAllSchools: function getAllSchools(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    __WEBPACK_IMPORTED_MODULE_0__api_teacher__["a" /* default */].getAllSchools().then(function (response) {
      commit('setSchools', { schools: response.rows });
      if (response.rows.length > 0) {
        commit('setSchool', response.rows[0]);

        __WEBPACK_IMPORTED_MODULE_0__api_teacher__["a" /* default */].getAllClass(response.rows[0].id).then(function (response) {
          commit('setGrades', response.rows);
          commit('setGrade', response.rows[0]);
        }).catch(function (e) {
          console.log(e);
        });
      }
    }).catch(function (e) {
      console.log(e);
    });
  },
  getAllSigninStudentList: function getAllSigninStudentList(_ref2, list) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_0__api_teacher__["a" /* default */].getAllSignInStudents(list).then(function (response) {
      commit("getAllSignInStudentsList", response.rows);
    }).catch(function (e) {});
  }
};
var mutations = {
  clear: function clear(state) {
    state.schools = [];
    state.grades = [];
    state.school = '选择学校';
    state.grade = '选择班级';
  },
  setSchools: function setSchools(state, payload) {
    state.schools = payload.schools;
  },
  setSchool: function setSchool(state, school) {
    state.school = school;
  },
  setGrades: function setGrades(state, grades) {
    state.grades = grades;
  },
  setGrade: function setGrade(state, grade) {
    state.grade = grade;
  },
  studentList: function studentList(state, list) {
    state.listStudents = list;
  },
  studentId: function studentId(state, index) {
    state.index = index;
  },
  selectedCourse: function selectedCourse(state, value) {
    state.selectedCourse = value;
  },
  getAllSignInStudentsList: function getAllSignInStudentsList(state, value) {
    state.studentList = value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__ = __webpack_require__(171);




var state = {
  user: JSON.parse(__WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__["a" /* default */].getData('user')),
  loginInfo: JSON.parse(__WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__["a" /* default */].getData('loginInfo')) };

var getters = {
  getUserInfo: function getUserInfo(state) {
    return state.user;
  },
  getLoginInfo: function getLoginInfo(state) {
    return state.loginInfo;
  }
};

var mutations = {
  clearUserInfo: function clearUserInfo(state) {
    state.user = false;
    __WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__["a" /* default */].removeData('user');
    __WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__["a" /* default */].removeData('token');
  },
  receivedUserInfoFromRemote: function receivedUserInfoFromRemote(state, payload) {
    state.user = payload.user[0];
    __WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__["a" /* default */].addData('user', payload.user[0]);
    __WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__["a" /* default */].addData('token', payload.user[0].token);
  },
  receivedUserInfoFromLocal: function receivedUserInfoFromLocal(state, user) {
    state.user = user;
  },
  reIcon: function reIcon(state, payload) {
    state.user.avatar = payload.icon;
    __WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__["a" /* default */].addData('user', state.user);
  },
  clearLoginInfo: function clearLoginInfo(state) {
    state.loginInfo = false;
    __WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__["a" /* default */].removeData('loginInfo');
  },
  saveLoginInfo: function saveLoginInfo(state, loginInfo) {
    state.loginInfo = loginInfo;
    __WEBPACK_IMPORTED_MODULE_0__localstorage_localStorage__["a" /* default */].addData('loginInfo', state.loginInfo);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    width: {
      type: Number,
      default: 800
    },
    height: {
      type: Number,
      default: 300
    },
    lineWidth: {
      type: Number,
      default: 4
    },
    lineColor: {
      type: String,
      default: '#000000'
    },
    bgColor: {
      type: String,
      default: ''
    },
    isCrop: {
      type: Boolean,
      default: false
    },
    isClearBgColor: {
      type: Boolean,
      default: true
    },
    format: {
      type: String,
      default: 'image/png'
    },
    quality: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      hasDrew: false,
      resultImg: '',
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      isDrawing: false,
      sratio: 1
    };
  },

  computed: {
    ratio: function ratio() {
      return this.height / this.width;
    },
    stageInfo: function stageInfo() {
      return this.$refs.canvas.getBoundingClientRect();
    },
    myBg: function myBg() {
      return this.bgColor ? this.bgColor : 'rgba(255, 255, 255, 0)';
    }
  },
  watch: {
    'myBg': function myBg(newVal) {
      this.$refs.canvas.style.background = newVal;
    }
  },
  beforeMount: function beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler);
  },
  mounted: function mounted() {
    var _this = this;

    var canvas = this.$refs.canvas;
    canvas.height = this.height;
    canvas.width = this.width;
    canvas.style.background = this.myBg;
    this.$_resizeHandler();
    // 在画板以外松开鼠标后冻结画笔
    document.onmouseup = function () {
      _this.isDrawing = false;
    };
  },

  methods: {
    $_resizeHandler: function $_resizeHandler() {
      var canvas = this.$refs.canvas;
      canvas.style.width = this.width + "px";
      var realw = parseFloat(window.getComputedStyle(canvas).width);
      canvas.style.height = this.ratio * realw + "px";
      this.canvasTxt = canvas.getContext('2d');
      this.canvasTxt.scale(1 * this.sratio, 1 * this.sratio);
      this.sratio = realw / this.width;
      this.canvasTxt.scale(1 / this.sratio, 1 / this.sratio);
    },

    // pc
    mouseDown: function mouseDown(e) {
      e = e || event;
      e.preventDefault();
      this.isDrawing = true;
      this.hasDrew = true;
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawStart(obj);
    },
    mouseMove: function mouseMove(e) {
      e = e || event;
      e.preventDefault();
      if (this.isDrawing) {
        var obj = {
          x: e.offsetX,
          y: e.offsetY
        };
        this.drawMove(obj);
      }
    },
    mouseUp: function mouseUp(e) {
      e = e || event;
      e.preventDefault();
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawEnd(obj);
      this.isDrawing = false;
    },

    // mobile
    touchStart: function touchStart(e) {
      e = e || event;
      e.preventDefault();
      this.hasDrew = true;
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawStart(obj);
      }
    },
    touchMove: function touchMove(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawMove(obj);
      }
    },
    touchEnd: function touchEnd(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawEnd(obj);
      }
    },

    // 绘制
    drawStart: function drawStart(obj) {
      this.startX = obj.x;
      this.startY = obj.y;
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
    },
    drawMove: function drawMove(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.strokeStyle = this.lineColor;
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.startY = obj.y;
      this.startX = obj.x;
      this.points.push(obj);
    },
    drawEnd: function drawEnd(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
      this.points.push({ x: -1, y: -1 });
    },

    // 操作
    generate: function generate(options) {
      var _this2 = this;

      var imgFormat = options && options.format ? options.format : this.format;
      var imgQuality = options && options.quality ? options.quality : this.quality;
      var pm = new Promise(function (resolve, reject) {
        if (!_this2.hasDrew) {
          reject('Warning: Not Signned!');
          return;
        }
        var resImgData = _this2.canvasTxt.getImageData(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.globalCompositeOperation = "destination-over";
        _this2.canvasTxt.fillStyle = _this2.myBg;
        _this2.canvasTxt.fillRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.resultImg = _this2.$refs.canvas.toDataURL(imgFormat, imgQuality);
        var resultImg = _this2.resultImg;
        _this2.canvasTxt.clearRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.putImageData(resImgData, 0, 0);
        _this2.canvasTxt.globalCompositeOperation = "source-over";
        if (_this2.isCrop) {
          var _canvasTxt;

          var crop_area = _this2.getCropArea(resImgData.data);
          var crop_canvas = document.createElement('canvas');
          var crop_ctx = crop_canvas.getContext('2d');
          crop_canvas.width = crop_area[2] - crop_area[0];
          crop_canvas.height = crop_area[3] - crop_area[1];
          var crop_imgData = (_canvasTxt = _this2.canvasTxt).getImageData.apply(_canvasTxt, _toConsumableArray(crop_area));
          crop_ctx.globalCompositeOperation = "destination-over";
          crop_ctx.putImageData(crop_imgData, 0, 0);
          crop_ctx.fillStyle = _this2.myBg;
          crop_ctx.fillRect(0, 0, crop_canvas.width, crop_canvas.height);
          resultImg = crop_canvas.toDataURL(imgFormat, imgQuality);
          crop_canvas = null;
        }
        resolve(resultImg);
      });
      return pm;
    },
    reset: function reset() {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      if (this.isClearBgColor) {
        this.$emit('update:bgColor', '');
        this.$refs.canvas.style.background = 'rgba(255, 255, 255, 0)';
      }
      this.points = [];
      this.hasDrew = false;
      this.resultImg = '';
    },
    getCropArea: function getCropArea(imgData) {
      var topX = this.$refs.canvas.width;var btmX = 0;var topY = this.$refs.canvas.height;var btnY = 0;
      for (var i = 0; i < this.$refs.canvas.width; i++) {
        for (var j = 0; j < this.$refs.canvas.height; j++) {
          var pos = (i + this.$refs.canvas.width * j) * 4;
          if (imgData[pos] > 0 || imgData[pos + 1] > 0 || imgData[pos + 2] || imgData[pos + 3] > 0) {
            btnY = Math.max(j, btnY);
            btmX = Math.max(i, btmX);
            topY = Math.min(j, topY);
            topX = Math.min(i, topX);
          }
        }
      }
      topX++;
      btmX++;
      topY++;
      btnY++;
      var data = [topX, topY, btmX, btnY];
      return data;
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {},
  data: function data() {
    return {};
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attendance-Item',
  props: {
    course: {
      type: Object
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },

  methods: {
    toggle: function toggle() {
      this.visible = !this.visible;
    }
  },
  computed: {}
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'blue-btn',
  data: function data() {
    return {};
  },

  props: {
    info: String,
    handleClick: Function
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'card-view',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_teacher__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'check-in-item',
  props: {
    student: {
      type: Object
    },
    reasons: {
      type: Array
    },
    position: {
      type: Number
    },
    userImage: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      aaa: '',
      index: 100,
      isColor: false
    };
  },

  methods: {
    checkIn: function checkIn(params) {
      this.student.dictCodeId = '';

      params.event.stopPropagation();
      if (this.student.isArrears) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["Toast"])({ message: '该学生已经没有课时了', position: 'middle', duration: 1500 });
        return;
      }

      this.student.checked = !this.student.checked;
      if (this.student.checked) {
        this.$emit('itemChecked', params.normal, this.position);
      } else {
        this.$emit('itemChecked', '', this.position);
      }
    },
    toggleReason: function toggleReason() {
      if (this.student.isArrears) {
        this.student.visible = false;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui__["Toast"])({ message: '该学生已经没有课时了', position: 'middle', duration: 1500 });
      } else {
        this.student.visible = !this.student.visible;
      }
    },
    itemChecked: function itemChecked(_ref) {
      var index = _ref.index;

      this.student.dictCodeId = this.reasons[index].dictValue;
      this.index = index;
      this.student.checked = false;
      this.$emit('itemChecked', this.chooseReason.dictValue, this.position);
    },
    upImage: function upImage(position) {
      this.$store.commit('studentId', position);

      this.$store.commit('studentList', this.student);
      this.$router.push({

        path: '/UpImage'
      });
    }
  },
  computed: {
    chooseReason: function chooseReason() {
      return this.reasons[this.index];
    }
  },
  components: { Toast: __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Toast"] },
  watch: {
    "student": {
      handler: function handler(newVal, oldVal) {}
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item-user-profile',
  props: {
    itemName: {
      type: String,
      default: ''
    },
    itemContent: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_myclass__ = __webpack_require__(98);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news-item',
  props: {
    item: {
      type: Object
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    look: function look(id, signStatus, status, createTimes) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api_myclass__["a" /* default */].getSignatureImage({ id: id, signStatus: signStatus, status: status, createTimes: createTimes }).then(function (response) {
        _this.$store.commit('SelectSignature', response.data);
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      transitionName: 'slide-left'
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var isBack = this.$router.isBack;
    if (isBack) {
      this.transitionName = 'slide-right';
    } else {
      this.transitionName = 'slide-left';
    }
    this.$router.isBack = false;
    next();
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    obj: {
      type: Object
    }
  },
  methods: {}
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    goback: function goback() {
      this.$emit('exit');
      this.$router.goBack();
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    obj: {
      type: Object
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: {
    obj: {
      type: Object
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String
    }
  },
  methods: {
    goback: function goback() {
      this.$router.goBack();
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    jump: function jump() {
      if (this.typeIcon === 'B') {
        this.$router.push({ path: '/record-TecComment' });
      }
    }
  },
  props: {
    typeIcon: {
      type: String
    },
    title: {
      type: String,
      default: '瓦酷教育'
    },
    recordModel: {
      type: Object
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-title',
  props: {
    pageTitle: String
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'work-item',
  props: {
    index: Number,
    title: String,
    finished: Boolean
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_teacher__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'worker-filter',
  data: function data() {
    return {
      isSelectSchool: false,
      isSelectGrade: false
    };
  },

  methods: {
    handleSchoolClick: function handleSchoolClick() {
      this.isSelectSchool = !this.isSelectSchool;
      if (this.isSelectSchool) {
        this.isSelectGrade = false;
      }
    },
    setSchool: function setSchool(_ref) {
      var _this = this;

      var school = _ref.school;

      __WEBPACK_IMPORTED_MODULE_2__api_teacher__["a" /* default */].getAllClass(school.id).then(function (response) {
        _this.$store.commit('setGrade', response.rows[0]);
        _this.$store.commit('setGrades', response.rows);
      }).catch(function (e) {
        console.log(e);
      });
      this.$store.commit('setSchool', school);
      this.isSelectSchool = false;
    },
    handleGradeClick: function handleGradeClick() {
      this.isSelectGrade = !this.isSelectGrade;
      if (this.isSelectGrade) {
        this.isSelectSchool = false;
      }
    },
    setGrade: function setGrade(_ref2) {
      var grade = _ref2.grade;

      this.$store.commit('setGrade', grade);
      this.$emit('gradeSelect');
      this.isSelectGrade = false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    schools: 'schools',
    school: 'school',
    grade: 'grade',
    grades: 'grades'
  }))
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Qiniu__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Qiniu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_Qiniu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_postmsg__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_netTool__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'headerPeople',
  created: function created() {},
  data: function data() {
    return {
      uploader: '',
      uptoken: '',
      inputId: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])({
    user: 'getUserInfo'
  }), {
    icon: function icon() {
      return this.user.avatar;
    },
    name: function name() {
      return this.user.userName;
    },
    other: function other() {
      return this.user.roleName;
    }
  }),
  watch: {},
  methods: {
    clickSet: function clickSet() {
      this.router.push();
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AttendanceItem_vue__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AttendanceItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AttendanceItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_teacher__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attendance',
  created: function created() {
    this.getAttendanceList();
  },
  destroy: function destroy() {
    this.$destroy();
  },
  data: function data() {
    return {
      courseList: [{
        course_title: 'python',
        absenteeism_count: 2,
        created_at: new Date().toLocaleString(),
        absence_user: [{
          id: 1,
          username: '张三'
        }, {
          id: 2,
          username: '李四'
        }]
      }, {
        course_title: 'c++',
        absenteeism_count: 1,
        created_at: new Date().toLocaleString(),
        absence_user: [{
          id: 1,
          username: '王五'
        }]
      }]
    };
  },

  methods: {
    getAttendanceList: function getAttendanceList() {}
  },
  components: {
    WorkerFilter: __WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue___default.a,
    VGoBackBtn: __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue___default.a,
    AttendanceItem: __WEBPACK_IMPORTED_MODULE_3__components_AttendanceItem_vue___default.a,
    Indicator: __WEBPACK_IMPORTED_MODULE_6_mint_ui__["Indicator"],
    Toast: __WEBPACK_IMPORTED_MODULE_6_mint_ui__["Toast"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])({
    school: 'school',
    grade: 'grade'
  }))
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  created: function created() {
    var _that = this;
    this.timer = setTimeout(function () {
      _that.goToLogin();
    }, 2000);
  },
  data: function data() {
    return {
      timer: ''
    };
  },

  methods: {
    goToLogin: function goToLogin() {
      clearTimeout(this.timer);
      this.$router.push({ path: '/login' });
    }
  },
  destroy: function destroy() {
    clearTimeout(this.timer);
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_login__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_netTool__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  created: function created() {
    window.handleCid = this.handleCid;
    if (this.loginInfo) {
      this.mobile = this.loginInfo.mobile;
      this.password = this.loginInfo.password;
    }
  },
  destroy: function destroy() {
    window.handleCid = undefined;
  },
  deactivated: function deactivated() {
    this.$destroy();
  },
  data: function data() {
    return {
      phoneErrorMessage: '手机号格式不正确',
      isValidPhoneNumber: true,
      isBlured: false,
      isRemember: true,
      mobile: '',
      password: ''
    };
  },

  methods: {
    validatePhoneNumber: function validatePhoneNumber() {
      this.isBlured = true;
      var regExp = /^1[3456789]\d{9}$/;
      if (regExp.test(this.mobile)) {
        this.isValidPhoneNumber = true;
      } else {
        this.isValidPhoneNumber = false;
      }
    },
    login: function login() {
      var _this = this;

      if (this.isValidPhoneNumber) {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui__["Indicator"].open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        });
        __WEBPACK_IMPORTED_MODULE_2__api_login__["a" /* default */].login(this.mobile, this.password).then(function (response) {
          if (response.code == 500) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui__["Toast"])({
              message: response.msg,
              position: 'middle',
              duration: 3000
            });
          } else {
            _this.$store.commit('receivedUserInfoFromRemote', { user: response.result, isStoreLocal: _this.isRemember });
            if (_this.isRemember) {
              _this.$store.commit('saveLoginInfo', { mobile: _this.mobile, password: _this.password });
            } else {
              _this.$store.commit('clearLoginInfo');
            }
            _this.getCid();
            if (_this.user.roleId === 7) {
              _this.$router.push({ path: '/parent-main' });
            } else {
              _this.$router.push({ path: '/teacher-main' });
            }
          }


          __WEBPACK_IMPORTED_MODULE_1_mint_ui__["Indicator"].close();
        }).catch(function (e) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui__["Toast"])({
            message: e.message,
            position: 'middle',
            duration: 3000
          });
          __WEBPACK_IMPORTED_MODULE_1_mint_ui__["Indicator"].close();
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui__["Toast"])({
          message: "手机号格式不正确",
          position: 'middle',
          duration: 3000
        });
      }
    },
    handleMobileChange: function handleMobileChange(text) {
      console.log(text);
    },
    handleRememberClick: function handleRememberClick() {
      this.isRemember = !this.isRemember;
    },
    handleCid: function handleCid(cid) {
      if (!cid || cid === 'null') {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_netTool__["a" /* default */].uploadCid({
        user_id: this.$store.state.userInfo.user.user_id,
        clientid: cid,
        client_source_type: this.clientType
      }).then(function (response) {
        if (response.errno === '0') {
          console.log('cid success post to server!');
        } else {
          console.log('cid success post to server!');
        }
      }).catch(function (e) {
        console.log(e.message);
      });
    },
    isAndroid: function isAndroid() {
      return navigator.userAgent.indexOf('Android') > -1;
    },
    isIOS: function isIOS() {
      return navigator.userAgent.indexOf('iPhone') > -1;
    },
    getCid: function getCid() {
      if (this.clientType === 10 && window.jsbridge && window.jsbridge.getClientId) {
        window.jsbridge.getClientId();
      } else if (this.clientType === 20 && window.getClientId) {
        window.getClientId();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    user: 'getUserInfo',
    loginInfo: 'getLoginInfo'
  }), {
    clientType: function clientType() {
      return this.isAndroid() ? 10 : this.isIOS() ? 20 : 0;
    }
  })
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_myclass__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VTitle_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewsItem_vue__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewsItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_NewsItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_PictureView__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_PictureView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_PictureView__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'my-class',
  data: function data() {
    return {
      newsList: [],
      value: '',
      isCustom: false,
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          var year = new Date().getFullYear();

          return date.getFullYear() > year;
        }
      },
      bScroll: '',
      iScroll: '',

      largeView: false,
      imgs: [],
      index: 0,
      scrollTop: 0,
      scrollDiv: {},
      loadingState: 1 };
  },

  methods: {
    historyClass: function historyClass() {
      this.customImage();
    },
    customImage: function customImage() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_myclass__["a" /* default */].getCustomSignatureImage().then(function (response) {
        if (response.data.length > 0) {
          _this.isCustom = true;

          _this.$store.commit('SelectSignature', response.data[0].imgUrl);

          _this.$store.commit('CustomSignature', response.data[0].id);
        } else {
          _this.isCustom = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    handleChange: function handleChange(e) {
      var _this2 = this;

      this.setLoadingState(2);
      var date = new Date(e);
      var year = date.getFullYear();
      __WEBPACK_IMPORTED_MODULE_1__api_myclass__["a" /* default */].getSignatureList(year).then(function (response) {
        _this2.newsList = [];
        if (response.rows.length != 0) {
          setTimeout(function () {
            _this2.setLoadingState(1);
            _this2.newsList = response.rows;
          }, 300);
        } else {
          _this2.setLoadingState(4);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    refresh: function refresh() {
      this.getList();
      this.$refs.refresh.onTopLoaded();
    },
    loadMore: function loadMore() {
      this.getList();
    },
    getList: function getList() {
      var _this3 = this;

      this.setLoadingState(2);
      var year = new Date().getFullYear();
      __WEBPACK_IMPORTED_MODULE_1__api_myclass__["a" /* default */].getSignatureList(year).then(function (response) {
        _this3.newsList = response.rows;

        _this3.setLoadingState(1);
      }).catch(function (e) {
        _this3.setLoadingState(5);
      });
    },
    handleClose: function handleClose() {
      this.imgs = [];
      this.index = 0;
    },
    setLoadingState: function setLoadingState(state) {
      this.loadingState = state;
    }
  },
  computed: {
    stateText: function stateText() {
      var text = '';
      switch (this.loadingState) {
        case 1:
          text = '';
          break;
        case 2:
          text = '加载中...';
          break;
        case 3:
          text = '到底了...';
          break;
        case 4:
          text = '暂无记录';
          break;
        case 5:
          text = '请检查您的网络';
          break;
      }
      return text;
    }
  },
  created: function created() {
    var _that = this;
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
      _that.scrollDiv = document.getElementById('scroll-wrapper');
      _that.scrollDiv.onscroll = function () {
        _that.scrollTop = this.scrollTop;
      };
    });

    this.getList();
  },
  activated: function activated() {
    this.scrollDiv.scrollTop = this.scrollTop;
  },
  mounted: function mounted() {
    this.customImage();
  },

  components: { VTitle: __WEBPACK_IMPORTED_MODULE_3__components_VTitle_vue___default.a, NewsItem: __WEBPACK_IMPORTED_MODULE_4__components_NewsItem_vue___default.a, Loadmore: __WEBPACK_IMPORTED_MODULE_0_mint_ui__["Loadmore"], PictureView: __WEBPACK_IMPORTED_MODULE_5__views_PictureView___default.a },
  route: {}
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_peopleHeader__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_peopleHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_peopleHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VShowCell__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VShowCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VShowCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_record_js__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'myRecord',
  data: function data() {
    return {};
  },

  methods: {},
  components: { peopleHeader: __WEBPACK_IMPORTED_MODULE_1__components_peopleHeader___default.a, VShowCell: __WEBPACK_IMPORTED_MODULE_2__components_VShowCell___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    user: 'getUserInfo',
    school: 'school',
    grade: 'grade'
  }))
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_teacher__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_netTool__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      result: {}
    };
  },
  created: function created() {
    this.getData();
  },

  components: { VTitle: __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue___default.a, VGoBackBtn: __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue___default.a },
  methods: {
    getData: function getData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api_teacher__["a" /* default */].getStudentProfileInfo().then(function (response) {
        _this.result = response.rows[0];
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VCoureseShowCell_vue__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VCoureseShowCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VCoureseShowCell_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_netTool__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui__);








__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_mint_ui__["InfiniteScroll"]);
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      arrayData: [],
      currentPage: 0,
      totalPage: {},
      disable: false,
      loadingState: 1 };
  },

  components: { VTitle: __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue___default.a, VCoureseShowCell: __WEBPACK_IMPORTED_MODULE_1__components_VCoureseShowCell_vue___default.a, VGoBackBtn: __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue___default.a },
  methods: {
    loadMore: function loadMore() {
      this.currentPage++;
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__api_netTool__["a" /* default */].completeCourse(this.currentPage).then(function (response) {
        if (_this.currentPage === 1) {
          _this.arrayData = response.data.list;
        } else {
          for (var i = 0; i < response.data.list.length; i++) {
            _this.arrayData.push(response.data.list[i]);
          }
        }
        _this.currentPage = response.data.pageNum;
        _this.totalPage = response.data.pageSize;
        _this.disable = _this.currentPage >= _this.totalPage;
        if (_this.disable) {
          if (_this.arrayData.length === 0) {
            _this.setLoadingState(4);
          } else {
            _this.setLoadingState(3);
          }
        } else {
          _this.setLoadingState(1);
        }
      }).catch(function (e) {
        _this.setLoadingState(5);
      });
    },
    setLoadingState: function setLoadingState(state) {
      this.loadingState = state;
    }
  },
  computed: {
    stateText: function stateText() {
      var text = '';
      switch (this.loadingState) {
        case 1:
          text = '';
          break;
        case 2:
          text = '加载中...';
          break;
        case 3:
          text = '到底了...';
          break;
        case 4:
          text = '暂无记录';
          break;
        case 5:
          text = '请检查您的网络';
          break;
      }
      return text;
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VTitle_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VMyNew_vue__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VMyNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VMyNew_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_netTool__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(11);










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_mint_ui__["InfiniteScroll"]);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'myNew',
  data: function data() {
    return {
      myNew: []
    };
  },
  created: function created() {
    this.Notice();
  },

  components: { VTitle: __WEBPACK_IMPORTED_MODULE_2__components_VTitle_vue___default.a, VMyNew: __WEBPACK_IMPORTED_MODULE_3__components_VMyNew_vue___default.a, VGoBackBtn: __WEBPACK_IMPORTED_MODULE_4__components_VGoBackBtn_vue___default.a },
  methods: {
    Notice: function Notice() {
      var _this = this;

      var schoolId = 0;
      var gradeId = 0;
      if (this.user.user_role.user_type === 1) {
        schoolId = this.user.user_role.school_id;
        gradeId = this.user.user_role.grade_id;
      } else {
        schoolId = this.school.school_id;
        gradeId = this.grade.grade_id;
      }
      var params = {
        'type': '1',
        school_id: schoolId,
        grade_id: gradeId
      };
      __WEBPACK_IMPORTED_MODULE_6__api_netTool__["a" /* default */].notice(params).then(function (response) {
        if (response.errno === '0') {
          _this.myNew = response.result;
        } else {
          console.log(response.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])({
    user: 'getUserInfo',
    school: 'school',
    grade: 'grade'
  }))
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VTitle_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    if (this.photosInfo.page === 0) {
      this.loadMore();
    }
    var _that = this;
    this.$nextTick(function () {
      _that.scrollDiv = this.$refs.scroll;
      this.scrollDiv.scrollTop = this.photosInfo.scrollTop;
      _that.scrollDiv.onscroll = function () {
        console.log(this.scrollTop);
        _that.$store.commit('setScrollTop', this.scrollTop);
      };
    });
  },
  data: function data() {
    return {
      scrollDiv: {}
    };
  },
  activated: function activated() {
    console.log(this.photosInfo.scrollTop);
    this.scrollDiv.scrollTop = this.photosInfo.scrollTop;
  },

  components: { VGoBackBtn: __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue___default.a, VTitle: __WEBPACK_IMPORTED_MODULE_2__components_VTitle_vue___default.a },
  methods: {
    loadMore: function loadMore() {
      if (!this.photosInfo.disable) {
        this.$store.dispatch('getPhotos', { toastInfo: this.toastInfo });
      }
    },
    exit: function exit() {
      console.log(1111);
    },
    click: function click(params) {
      var index = params.index;
      this.$store.commit('setImgInfo', { imgs: this.photosInfo.photos, index: index });
      this.$router.push({ path: '/picture-view' });
    },
    toastInfo: function toastInfo(msg) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({ message: msg, position: 'middle', duration: 3000 });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['photosInfo', 'loadingText']))

});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VMessage_vue__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_netTool__ = __webpack_require__(25);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      data: []
    };
  },
  created: function created() {
    this.getdata();
  },

  components: { VTitle: __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue___default.a, VMessage: __WEBPACK_IMPORTED_MODULE_1__components_VMessage_vue___default.a, VGoBackBtn: __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue___default.a },
  methods: {
    getdata: function getdata() {
      var _this = this;

      var params = {
        'type': '2'
      };
      __WEBPACK_IMPORTED_MODULE_3__api_netTool__["a" /* default */].notice(params).then(function (response) {
        if (response.errno === '0') {
          _this.data = response.result;
        } else {
          console.log(response.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_netTool__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      obj: {
        title: '',
        teachingObjectives: '',
        teachingProcess: '',
        imageUrl: []
      }
    };
  },
  created: function created() {
    this.getData();
  },
  deactivated: function deactivated() {
    this.$destroy();
  },

  components: { VTitle: __WEBPACK_IMPORTED_MODULE_0__components_VTitle_vue___default.a, VGoBackBtn: __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue___default.a },

  methods: {
    getData: function getData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api_netTool__["a" /* default */].detailCourse(this.$route.query.id).then(function (response) {
        if (response.code == '0') {
          _this.obj = response.data;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({ message: response.msg, position: 'middle', duration: 3000 });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleClick: function handleClick(params) {
      var index = params.index;
      this.$store.commit('setImgInfo', { imgs: this.obj.imageUrl, index: index });
      this.$router.push({ path: '/picture-view' });
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'parent-main',
  destroyed: function destroyed() {}
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'picture-view',
  created: function created() {
    this.imageObj = new Image();
    var _that = this;
    this.imageObj.onload = function () {
      _that.w = this.width;
      _that.h = this.height;
    };
    this.imageObj.src = this.img;
  },
  updated: function updated() {},
  deactivated: function deactivated() {
    this.$destroy();
  },

  methods: {
    handlePre: function handlePre() {
      if (this.mIndex === 0) {
        console.log('this is first img');
        return;
      }
      this.mIndex--;
      this.imageObj.src = this.img;
    },
    handleNext: function handleNext() {
      if (this.mIndex === this.imgs.length - 1) {
        console.log('this is last img');
        return;
      }
      this.mIndex++;
      this.imageObj.src = this.img;
    },
    close: function close() {
      this.$store.commit('clearImgInfo');
      this.$router.goBack();
    }
  },
  data: function data() {
    return {
      mIndex: this.$store.state.pictureView.index,
      imageObj: {},
      w: 0,
      h: 0,
      imgs: this.$store.state.pictureView.imgs
    };
  },

  computed: {
    img: function img() {
      if (this.imgs[this.mIndex]) {
        return this.imgs[this.mIndex];
      } else {
        return '';
      }
    },
    width: function width() {
      var winWidth = window.innerWidth;
      var winHeight = window.innerHeight;
      var realW = winHeight / this.h * this.w;
      if (this.h / this.w > 1.2) {
        return realW;
      } else {
        return winWidth;
      }
    },
    height: function height() {
      var winWidth = window.innerWidth;
      var winHeight = window.innerHeight;
      var realH = winWidth / this.w * this.h;
      if (this.h / this.w > 1.2) {
        return winHeight;
      } else {
        return realH;
      }
    },
    paddingLeft: function paddingLeft() {
      var winWidth = window.innerWidth;
      var winHeight = window.innerHeight;
      var realW = winHeight / this.h * this.w;
      var paddingLeft = parseInt((winWidth - realW) / 2);
      if (this.h / this.w > 1.2) {
        return paddingLeft;
      } else {
        return 0;
      }
    },
    paddingTop: function paddingTop() {
      var winWidth = window.innerWidth;
      var winHeight = window.innerHeight;
      var realH = winWidth / this.w * this.h;
      var paddingTop = parseInt((winHeight - realH) / 2);
      if (this.h / this.w > 1.2) {
        return 0;
      } else {
        return paddingTop;
      }
    },
    styleObj: function styleObj() {
      return {
        height: this.height + 'px',
        width: this.width + 'px',
        paddingLeft: this.paddingLeft + 'px',
        paddingTop: this.paddingTop + 'px'
      };
    }
  },
  watch: {
    "img": {
      handler: function handler(newVal, oldVal) {
        console.log(newVal, "///");
      }
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WorkerFilter_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WorkerFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_WorkerFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VTitle_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CheckInItem_vue__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CheckInItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CheckInItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CardView_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CardView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_CardView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_teacher__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_studentImageLsit__ = __webpack_require__(172);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'student-check-in',
  created: function created() {
    this.getAllSignInStatus();
  },
  data: function data() {
    return {
      reasons: [],
      student: [],

      selectedCourse: this.$store.state.teacherschools.selectedCourse,
      selectedStudents: [],
      lessons: ''
    };
  },

  components: {
    WorkerFilter: __WEBPACK_IMPORTED_MODULE_2__components_WorkerFilter_vue___default.a,
    VTitle: __WEBPACK_IMPORTED_MODULE_3__components_VTitle_vue___default.a,
    CheckInItem: __WEBPACK_IMPORTED_MODULE_4__components_CheckInItem_vue___default.a,
    CardView: __WEBPACK_IMPORTED_MODULE_5__components_CardView_vue___default.a
  },
  mounted: function mounted() {
    this.handleComputedValue();
  },

  methods: {
    handleComputedValue: function handleComputedValue() {
      var _this = this;

      if (this.filteredStudents.length != 0) {
        if (__WEBPACK_IMPORTED_MODULE_9__utils_studentImageLsit__["a" /* list */].length != 0) {
          __WEBPACK_IMPORTED_MODULE_9__utils_studentImageLsit__["a" /* list */].forEach(function (item) {
            _this.filteredStudents[item.id].userImage = item.imgList;
          });
        }
      }
    },
    getAllSignInStatus: function getAllSignInStatus() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__api_teacher__["a" /* default */].getAllQueryTheSignInStatus().then(function (response) {
        _this2.reasons = response.data;
      });
    },
    back: function back(params) {
      var _this3 = this;

      if (this.filteredStudents.length != 0) {
        if (__WEBPACK_IMPORTED_MODULE_9__utils_studentImageLsit__["a" /* list */].length != 0) {
          __WEBPACK_IMPORTED_MODULE_9__utils_studentImageLsit__["a" /* list */].forEach(function (item) {
            _this3.filteredStudents[item.id].userImage = [];
            _this3.filteredStudents[item.id].normal = '';
          });
        }
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_studentImageLsit__["b" /* studentImageList */])('');
      this.$router.goBack();
    },
    getAllStudents: function getAllStudents() {
      this.$store.dispatch('getAllSigninStudentList', { campusId: this.school.id, classId: this.grade.id, lessons: this.lessons });
    },
    itemChecked: function itemChecked(normal, index) {
      this.filteredStudents[index].normal = normal;
    },
    submit: function submit() {
      var _this4 = this;

      if (this.filteredStudents.length <= 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mint_ui__["Toast"])({ message: '没有签到学生', position: 'middle', duration: 3000 });
        return;
      } else {
        for (var index = 0; index < this.filteredStudents.length; index++) {
          if (this.filteredStudents[index].isArrears) {
            continue;
          }

          var student = this.filteredStudents[index];
          if (student.normal === '') {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mint_ui__["Toast"])({ message: '\u6CA1\u6709\u586B\u5199' + student.userName + '\u7F3A\u52E4\u7684\u539F\u56E0', position: 'middle', duration: 3000 });
            return false;
          }
        }
        __WEBPACK_IMPORTED_MODULE_7_mint_ui__["Indicator"].open({ text: '正在签到...', spinnerType: 'fading-circle', duration: 2000 });
        __WEBPACK_IMPORTED_MODULE_6__api_teacher__["a" /* default */].createSignIn(this.filteredStudents).then(function (response) {
          if (response.msg === '操作成功') {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_studentImageLsit__["b" /* studentImageList */])('');
            _this4.$store.commit('selectedCourse', '');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mint_ui__["Toast"])({ message: '签到成功', position: 'bottom', duration: 3000 });
            _this4.getAllStudents();
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mint_ui__["Toast"])({ message: response.message, position: 'middle', duration: 3000 });
          }
          __WEBPACK_IMPORTED_MODULE_7_mint_ui__["Indicator"].close();
        }).catch(function (e) {
          __WEBPACK_IMPORTED_MODULE_7_mint_ui__["Indicator"].close();
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])({
    school: 'school',
    grade: 'grade',
    imgList: 'imgList',
    selectedCourseStore: 'selectedCourse'

  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapState */])({
    studentList: function studentList(state) {
      return state.teacherschools.studentList;
    }
  }), {
    filteredStudents: function filteredStudents() {
      var _this5 = this;

      if (this.selectedCourseStore) {
        var course = this.studentList.find(function (item) {
          return item.course_title === _this5.selectedCourseStore;
        });
        return course ? course.students : [];
      } else {
        return [];
      }
    }
  }),
  watch: {
    'selectedCourse': {
      handler: function handler(newValue, oldValue) {
        if (newValue) {
          this.$store.commit('selectedCourse', newValue);
        }
      }
    },
    'filteredStudents': {
      handler: function handler(newVal, oldVal) {
        var _this6 = this;

        newVal.forEach(function (value) {
          if (value.isArrears == true) {
            var properties = {
              normal: 5,
              schoolId: _this6.school.id,
              classId: _this6.grade.id,
              userImage: []
            };
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(value, properties);
          } else {
            var _properties = {
              normal: '',
              schoolId: _this6.school.id,
              classId: _this6.grade.id,
              userImage: []
            };

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(value, _properties);
          }
        });
      }
    },
    "studentList": {
      handler: function handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.selectedCourse = newVal[0].course_title;

          this.$store.commit('selectedCourse', newVal[0].course_title);
        } else {
          this.selectedCourse = '';
          this.$store.commit('selectedCourse', '');
        }
      }
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_teacher__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  created: function created() {
    window.addEventListener('online', this.handleNetworkChange);
    window.addEventListener('offline', this.handleNetworkChange);
    this.getAllStudentsByGrade();
    var _that = this;
    this.$nextTick(function () {
      _that.$refs.list.onscroll = function () {
        _that.scrollTop = this.scrollTop;
      };
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('online', this.handleNetworkChange);
    window.removeEventListener('offline', this.handleNetworkChange);
  },
  activated: function activated() {
    this.$refs.list.scrollTop = this.scrollTop;
  },
  data: function data() {
    return {
      isOnline: navigator.onLine,
      students: [],
      page: 1,
      totalPage: 0,
      disable: false,
      scrollTop: 0,
      loadingState: 1 };
  },

  methods: {
    getAllStudentsByGrade: function getAllStudentsByGrade() {
      var _this = this;

      this.disable = true;
      __WEBPACK_IMPORTED_MODULE_5_mint_ui__["Indicator"].open({ text: '获取中...', spinnerType: 'fading-circle' });
      __WEBPACK_IMPORTED_MODULE_3__api_teacher__["a" /* default */].getStudents(this.school.id, this.grade.id, this.page).then(function (response) {
        if (response.code == 0) {
          if (response.data.pageNum === 1) {
            _this.students = response.data.list;
          } else {
            _this.students = _this.students.concat(response.data.list);
          }
          _this.page = response.data.pageNum;
          _this.totalPage = response.data.pages;
          _this.disable = _this.page >= _this.totalPage;
          if (_this.disable) {
            if (_this.students.length === 0) {
              _this.setLoadingState(4);
            } else {
              _this.setLoadingState(3);
            }
          } else {
            _this.setLoadingState(1);
          }
        } else {
          _this.setLoadingState(4);
        }
        __WEBPACK_IMPORTED_MODULE_5_mint_ui__["Indicator"].close();
        _this.disable = _this.page === _this.totalPage;
      }).catch(function (e) {
        _this.setLoadingState(4);
        __WEBPACK_IMPORTED_MODULE_5_mint_ui__["Indicator"].close();
        _this.disable = false;
      });
    },
    loadMore: function loadMore() {
      if (this.loadingState != 4 && this.loadingState != 5) {
        this.page++;
        this.getAllStudentsByGrade();
      }
    },
    goToStudentInfo: function goToStudentInfo(_ref) {
      var student = _ref.student;

      this.$router.push({
        path: '/student-profile',
        query: {
          headId: student.id
        }
      });
    },
    setLoadingState: function setLoadingState(state) {
      this.loadingState = state;
    },
    handleNetworkChange: function handleNetworkChange() {
      this.isOnline = navigator.onLine;
      if (!this.isOnline) {
        this.setLoadingState(5);
      } else {
        this.getAllStudentsByGrade();
      }
    }
  },
  components: {
    VGoBackBtn: __WEBPACK_IMPORTED_MODULE_2__components_VGoBackBtn_vue___default.a,
    WorkerFilter: __WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue___default.a,
    Toast: __WEBPACK_IMPORTED_MODULE_5_mint_ui__["Toast"],
    Indicator: __WEBPACK_IMPORTED_MODULE_5_mint_ui__["Indicator"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    school: 'school',
    grade: 'grade'
  }), {
    stateText: function stateText() {
      var text = '';
      switch (this.loadingState) {
        case 1:
          text = '';
          break;
        case 2:
          text = '加载中...';
          break;
        case 3:
          text = '到底了...';
          break;
        case 4:
          text = '暂无记录';
          break;
        case 5:
          text = '请检查您的网络';
          break;
      }
      return text;
    }
  })
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ItemUserProfile_vue__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ItemUserProfile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ItemUserProfile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_teacher__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'student-profile-info',
  data: function data() {
    return {
      student: {}
    };
  },
  deactivated: function deactivated() {
    this.$destroy();
  },
  created: function created() {
    this.getProfile();
  },

  components: {
    ItemUserProfile: __WEBPACK_IMPORTED_MODULE_0__components_ItemUserProfile_vue___default.a, VGoBackBtn: __WEBPACK_IMPORTED_MODULE_1__components_VGoBackBtn_vue___default.a
  },
  methods: {
    getProfile: function getProfile() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api_teacher__["a" /* default */].getStudentProfileInfo(this.$route.query).then(function (response) {
        response.rows[0].sex = response.rows[0].sex == '0' ? '男' : '女';
        _this.student = response.rows[0];
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  computed: {}
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_peopleHeader__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_peopleHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_peopleHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VShowCell__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VShowCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VShowCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WorkItem__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WorkItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_WorkItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CardView__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CardView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CardView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_teacher__ = __webpack_require__(26);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher-info',
  activated: function activated() {
    this.getMessage();
  },
  data: function data() {
    return {
      record: ''
    };
  },

  methods: {
    getMessage: function getMessage() {}
  },
  components: {
    peopleHeader: __WEBPACK_IMPORTED_MODULE_0__components_peopleHeader___default.a,
    VShowCell: __WEBPACK_IMPORTED_MODULE_1__components_VShowCell___default.a,
    CardView: __WEBPACK_IMPORTED_MODULE_3__components_CardView___default.a,
    WorkItem: __WEBPACK_IMPORTED_MODULE_2__components_WorkItem___default.a
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher-main',
  created: function created() {
    this.$store.dispatch('getAllSchools');
  },

  methods: {},
  data: function data() {
    return {};
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BlueBtn_vue__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BlueBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_BlueBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CardView_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CardView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CardView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_face_api_js__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_studentImageLsit__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpImage',
  data: function data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      url:  true ? __WEBPACK_IMPORTED_MODULE_10__config___default.a.build.baseUrl + '/api/qinius' : config.dev.baseUrl + '/api/qinius',
      headers: {
        'token': __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.userInfo.user.token
      }
    };
  },

  components: { BlueBtn: __WEBPACK_IMPORTED_MODULE_2__components_BlueBtn_vue___default.a, CardView: __WEBPACK_IMPORTED_MODULE_3__components_CardView_vue___default.a },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.state.teacherschools.listStudents.userImage).length !== 0) {
      this.fileList = this.$store.state.teacherschools.listStudents.userImage;
    }
  },
  mounted: function mounted() {},

  methods: {
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeUpload: function beforeUpload(file) {
      var fileName = file.name;
      var fileType = fileName.substring(fileName.lastIndexOf('.'));
      var isOKType = fileType === '.jpg' || fileType === '.png' || fileType === '.jpeg' || fileType === '.bmp';
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isOKType) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])({ message: '图片格式只能为jpeg/png/jpg/bmp', position: 'middle', duration: 2000 });
        return false;
      } else if (!isLt2M) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])({ message: '图片大小不能超过 10MB!', position: 'middle', duration: 2000 });
        return false;
      }

      return isLt2M && isOKType;
    },
    handleRemove: function handleRemove(file, fileList) {
      for (var k = __WEBPACK_IMPORTED_MODULE_8__utils_studentImageLsit__["a" /* list */].length - 1; k >= 0; k--) {
        for (var i = __WEBPACK_IMPORTED_MODULE_8__utils_studentImageLsit__["a" /* list */][k].imgList.length - 1; i >= 0; i--) {
          if (__WEBPACK_IMPORTED_MODULE_8__utils_studentImageLsit__["a" /* list */][k].imgList[i].uid == file.uid) {
            __WEBPACK_IMPORTED_MODULE_8__utils_studentImageLsit__["a" /* list */][k].imgList.splice(i, 1);
          }
        }
      }
    },
    cancel: function cancel() {
      this.$router.goBack();
    },
    submits: function submits() {
      var _this = this;

      var hasRawProperty = this.fileList.some(function (item) {
        return item.hasOwnProperty('raw');
      });
      if (hasRawProperty) {
        this.fileList.forEach(function (el) {
          if (el.raw) {
            var fileData = new FormData();
            fileData.append('files', el.raw);
            fileData.append('imgId', el.raw.uid);

            __WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].post(_this.url, fileData).then(function (response) {
              if (response.data.msg == '操作成功') {
                var arr = new Array();
                var uid = response.data.uid.split(',');
                var name = response.data.newFileNames.split(',');
                var url = response.data.fileNames.split(',');
                var item = {};
                if (uid.length > 1) {
                  for (var i = 0; i < uid.length; i++) {
                    item = {
                      uid: uid[i],
                      name: name[i],
                      url: url[i]
                    };
                    arr.push(item);
                  }
                } else {
                  item = {
                    uid: response.data.uid,
                    name: response.data.newFileNames,
                    url: response.data.fileNames
                  };
                  arr.push(item);
                }

                var listItem = {
                  id: _this.$store.state.teacherschools.index,
                  imgList: arr
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_studentImageLsit__["b" /* studentImageList */])(listItem);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])({ message: '上传成功！', position: 'middle', duration: 2000 });
              }
            }).catch(function (error) {});
          }
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_mint_ui__["Toast"])({ message: '请上传新的照片！', position: 'middle', duration: 2000 });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])({
    studentList: 'studentList'
  })),
  watch: {}

});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'work',
  data: function data() {
    return {
      title: '我的工作',
      lessons: ''
    };
  },

  methods: {
    checkIn: function checkIn() {
      this.$router.push({
        path: '/student-check-in'
      });
    },
    studentList: function studentList() {
      this.$router.push({
        path: '/student-list'
      });
    },
    selectSign: function selectSign() {
      this.$store.dispatch('getAllSigninStudentList', { campusId: this.school.id, classId: this.grade.id, lessons: this.lessons });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    school: 'school',
    grade: 'grade'
  })),
  components: {
    WorkerFilter: __WEBPACK_IMPORTED_MODULE_1__components_WorkerFilter_vue___default.a
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VNavigator_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VNavigator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VNavigator_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      index: 0
    };
  },

  methods: {
    setIndex: function setIndex(params) {
      this.index = params.index;
    }
  },
  components: { VNavigator: __WEBPACK_IMPORTED_MODULE_0__components_VNavigator_vue___default.a }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VGoBackBtn_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VGoBackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VGoBackBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VNavigator_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VNavigator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VNavigator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_netTool__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VGoBackBtn: __WEBPACK_IMPORTED_MODULE_0__components_VGoBackBtn_vue___default.a, VNavigator: __WEBPACK_IMPORTED_MODULE_1__components_VNavigator_vue___default.a },
  methods: {
    tuichu: function tuichu() {
      this.$store.commit('clearUserInfo');
      this.$store.commit('clearLoginInfo');
      this.$store.commit('clear');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
        message: '退出成功',
        position: 'bottom',
        duration: 1000
      });
      this.$router.push({ path: '/login' });
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_image_preview_style__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_image_preview__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BlueBtn_vue__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BlueBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_BlueBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CardView_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CardView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_CardView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_myclass__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signature',
  data: function data() {
    return {
      maxImages: 9,
      upToken: '',
      upLoader: '',
      files: [],
      headerFileLength: 0,
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      isCrop: false,

      bgPic: '',

      resultImg: '',

      makePic: '' };
  },

  components: { BlueBtn: __WEBPACK_IMPORTED_MODULE_4__components_BlueBtn_vue___default.a, CardView: __WEBPACK_IMPORTED_MODULE_5__components_CardView_vue___default.a },
  created: function created() {
    this.makePic = '';
    this.bgPic = '';
  },
  mounted: function mounted() {
    if (this.$route.params.signStatus == '0') {
      this.$refs.esign.reset();
      this.bgPic = this.SelectSignature;
    } else {
      this.makePic = this.SelectSignature;
    }
  },

  methods: {
    showPreview: function showPreview() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_image_preview__["a" /* default */])([this.bgPic]);
    },
    showPreview1: function showPreview1() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_image_preview__["a" /* default */])([this.makePic]);
    },
    handleReset: function handleReset() {
      this.$refs.esign.reset();
      this.makePic = '';
    },
    drawProdPicture: function drawProdPicture() {
      var _this = this;

      this.$refs.esign.generate().then(function (res) {
        _this.resultImg = res;

        var img1 = new Image();
        img1.src = _this.bgPic;
        img1.setAttribute('crossOrigin', 'anonymous');
        img1.onload = function () {
          var canvas = document.createElement("canvas");
          var context = canvas.getContext("2d");
          context.canvas.willReadFrequently = true;
          canvas.width = img1.width;
          canvas.height = img1.height;
          context.drawImage(img1, 0, 0, img1.width, img1.height);

          var img2 = new Image();
          img2.src = _this.resultImg;
          img2.setAttribute('crossOrigin', 'anonymous');
          img2.width = 120;
          img2.height = 50;
          img2.onload = function () {

            var x = img1.width - img2.width - 80;
            var y = 0;
            context.drawImage(img2, x, y, img2.width, img2.height);

            var src = canvas.toDataURL('image/png');
            _this.makePic = src;
          };
        };
      }).catch(function (err) {
        _this.toastMsg('请签字！');
      });
    },
    cancel: function cancel() {
      this.$router.goBack();
    },
    submit: function submit() {
      var _this2 = this;

      if (this.makePic != '') {
        var fileData = new FormData();
        var binaryData = this.base64ToBinary(this.makePic);
        fileData.append('file', binaryData);

        if (this.$route.params.isCustom == 'false') {
          fileData.append('artworkMaster', this.bgPic);

          __WEBPACK_IMPORTED_MODULE_6__api_myclass__["a" /* default */].SubmitSignatureImage(fileData).then(function (response) {
            if (response.code == 0) {
              _this2.toastMsg('签字成功！');
              _this2.cancel();
            } else {
              _this2.toastMsg(response.msg);
            }
          }).catch(function (err) {
            _this2.toastMsg(err);
          });
        } else {
          fileData.append('id', this.$store.state.SelectSignature.CustomSignatureId);

          __WEBPACK_IMPORTED_MODULE_6__api_myclass__["a" /* default */].SubmitCustomSignatureImage(fileData).then(function (response) {
            if (response.code == 0) {
              _this2.toastMsg('签字成功！');
              _this2.cancel();
            } else {
              _this2.toastMsg(response.msg);
            }
          }).catch(function (err) {
            _this2.toastMsg(err);
          });
        }
      } else {
        this.toastMsg('请确认签字后再提交！');
      }
    },
    toastMsg: function toastMsg(msg) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mint_ui__["Toast"])({ message: msg, position: 'middle', duration: 3000 });
    },
    base64ToBinary: function base64ToBinary(base64String) {
      var base64Data = base64String.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');

      var binaryString = window.atob(base64Data);
      var length = binaryString.length;
      var bytes = new Uint8Array(length);

      for (var i = 0; i < length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      var blob = new Blob([bytes], { type: 'image/png' });
      return blob;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    SelectSignature: function SelectSignature(state) {
      return state.SelectSignature.SelectSignature;
    }
  })),
  watch: {
    "SelectSignature": {
      deep: true,
      handler: function handler(newVal, oldVal) {
        if (this.$route.params.signStatus == '0') {
          this.$refs.esign.reset();
          this.bgPic = newVal;
        } else {
          this.makePic = newVal;
        }
      }
    }
  }

});

/***/ }),
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_loading.47746de.png";

/***/ }),
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(493)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(775),
  /* scopeId */
  "data-v-48b8d45e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(476)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(758),
  /* scopeId */
  "data-v-13d025ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(780),
  /* scopeId */
  "data-v-6017be79",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  "data-v-748c59c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(494)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(776),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  "data-v-6cb0fc59",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  "data-v-9f5a8b1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(475)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(757),
  /* scopeId */
  "data-v-0d687580",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(482)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(764),
  /* scopeId */
  "data-v-23277806",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  "data-v-75f1a55e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(492)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(774),
  /* scopeId */
  "data-v-488b4384",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  "data-v-c3d9c19e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  "data-v-ad5b7d18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  "data-v-7e9d4cf6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  "data-v-631433be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(496)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(778),
  /* scopeId */
  "data-v-4ec371fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(488)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(770),
  /* scopeId */
  "data-v-37893e8a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(792),
  /* scopeId */
  "data-v-abc224c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(485)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(767),
  /* scopeId */
  "data-v-2f239327",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  "data-v-cf410534",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  "data-v-80b8ea2a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  "data-v-68d71f7a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(480)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(762),
  /* scopeId */
  "data-v-1dbe957e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(486)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(768),
  /* scopeId */
  "data-v-334b7cb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(481)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(763),
  /* scopeId */
  "data-v-1f0593f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(477)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(759),
  /* scopeId */
  "data-v-13e9b783",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  "data-v-f3c19870",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  "data-v-6f4b8d0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(487)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  "data-v-3529b9f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(483)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(765),
  /* scopeId */
  "data-v-28a9c290",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  "data-v-b0f7fdc0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(478)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(760),
  /* scopeId */
  "data-v-1920942c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "head"
  }), _vm._v(" "), _c('div', {
    staticClass: "mid"
  }, [_c('div', {
    staticClass: "time",
    domProps: {
      "textContent": _vm._s(_vm.obj.created_at)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    domProps: {
      "textContent": _vm._s(_vm.obj.message)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  })])
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleReason
      }),
      expression: "{methods:toggleReason}"
    }],
    staticClass: "item"
  }, [_c('span', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.checkIn,
        normal: 0
      }),
      expression: "{methods:checkIn,normal:0}"
    }],
    staticClass: "check",
    class: {
      checked: _vm.student.checked
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.student.userName)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "course",
    class: {
      warning: _vm.student.isArrears
    }
  }, [_vm._v("已上" + _vm._s(_vm.student.aboveCourse) + "节/共" + _vm._s(_vm.student.totalCourse) + "节")]), _vm._v(" "), _c('span', {
    staticClass: "right-arrow"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.student.visible),
      expression: "student.visible"
    }],
    staticClass: "reason"
  }, [_c('div', {
    staticClass: "right"
  }), _vm._v(" "), _c('div', {
    staticClass: "radio-list-wrapper"
  }, [_c('label', {
    staticClass: "radio-title"
  }, [_vm._v("缺勤原因")]), _vm._v(" "), _c('ul', _vm._l((_vm.reasons), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.itemChecked({
            index: index
          })
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.chooseReason),
        expression: "chooseReason"
      }],
      staticClass: "radio-input",
      attrs: {
        "type": "radio",
        "disabled": ""
      },
      domProps: {
        "value": item.dictValue,
        "checked": _vm._q(_vm.chooseReason, item.dictValue)
      },
      on: {
        "change": function($event) {
          _vm.chooseReason = item.dictValue
        }
      }
    }), _vm._v(" "), _c('span', {
      class: item.dictValue === _vm.student.dictCodeId ? 'selected' : 'radio-core'
    }), _vm._v(" "), _c('span', {
      staticClass: "radio-label"
    }, [_vm._v(_vm._s(item.dictLabel))])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teacher-bg"
  }, [_c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "tab-view"
  }, [_c('router-link', {
    attrs: {
      "to": "/work",
      "active-class": "u-link--Active1"
    }
  }, [_c('div', {
    staticClass: "tab work"
  }, [_vm._v("工 作")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/teacher-info",
      "active-class": "u-link--Active3"
    }
  }, [_c('div', {
    staticClass: "tab my"
  }, [_vm._v("我 的")])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    ref: "canvas",
    on: {
      "mousedown": _vm.mouseDown,
      "mousemove": _vm.mouseMove,
      "mouseup": _vm.mouseUp,
      "touchstart": _vm.touchStart,
      "touchmove": _vm.touchMove,
      "touchend": _vm.touchEnd
    }
  })
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parentgoback"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.goback
      }),
      expression: "{methods:goback}"
    }],
    staticClass: "btn"
  })])
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "list-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    ref: "list",
    staticClass: "list"
  }, [_c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "disable",
      "infinite-scroll-distance": "30"
    }
  }, _vm._l((_vm.students), function(student) {
    return _c('li', {
      directives: [{
        name: "tap",
        rawName: "v-tap",
        value: ({
          methods: _vm.goToStudentInfo,
          student: student
        }),
        expression: "{methods:goToStudentInfo,student:student}"
      }],
      key: student.id
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(student.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "class"
    }, [_vm._v(_vm._s(student.gradeName))]), _vm._v(" "), _c('i', {
      staticClass: "arrow"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "centerDiv"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.stateText)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('v-go-back-btn')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('peopleHeader')], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('VShowCell', {
    attrs: {
      "typeIcon": "A",
      "title": "我的信息"
    }
  }, [_c('p', {
    staticClass: "two"
  }, [_vm._v("通知")]), _vm._v(" "), _c('p', {
    staticClass: "two",
    domProps: {
      "textContent": _vm._s(_vm.record)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "message"
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unfinished",
    class: {
      finished: _vm.finished
    }
  }, [_c('span', {
    staticClass: "icon",
    class: {
      complete: _vm.finished
    },
    domProps: {
      "textContent": _vm._s(_vm.finished ? '' : _vm.index)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('VNavigator', {
    attrs: {
      "title": "设置与关于"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', [_c('router-link', {
    attrs: {
      "to": "/aboutUs"
    }
  }, [_c('div', {
    staticClass: "about1"
  }, [_vm._v("\n          关于我们\n          "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "jump"
  }, [_c('span', {
    staticClass: "arrow"
  })])])], 1), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jump"
  }, [_vm._v("\n        1.0\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.tuichu
      }),
      expression: "{methods:tuichu}"
    }],
    staticClass: "tuichu"
  }, [_vm._v("\n        退出\n      ")])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about2"
  }, [_vm._v("\n        版本\n        "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("\n      燕郊在线提供研发与技术服务\n    ")])])
}]}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.handleClick
      }),
      expression: "{methods:handleClick}"
    }],
    staticClass: "blue-btn"
  }, [_vm._v("\n  " + _vm._s(_vm.info) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "老师评语"
    }
  })], 1), _vm._v(" "), (_vm.data.length) ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.data), function(obj, index) {
    return _c('VMessage', {
      key: index,
      attrs: {
        "obj": obj
      }
    })
  }), 1) : _c('div', {
    staticClass: "nothing"
  }, [_vm._v("\n    您还没有评语噢~\n  ")]), _vm._v(" "), _c('div', [_c('VGoBackBtn')], 1)])
},staticRenderFns: []}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "user-info-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.student),
      expression: "student"
    }],
    staticClass: "user-profile"
  }, [_c('item-user-profile', {
    attrs: {
      "item-name": "姓名",
      "item-content": _vm.student.name
    }
  }), _vm._v(" "), _c('item-user-profile', {
    attrs: {
      "item-name": "性别",
      "item-content": _vm.student.sex
    }
  }), _vm._v(" "), _c('item-user-profile', {
    attrs: {
      "item-name": "生日",
      "item-content": _vm.student.birthday
    }
  }), _vm._v(" "), _c('item-user-profile', {
    attrs: {
      "item-name": "课次",
      "item-content": _vm.student.courseSummary
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "back-box"
  }, [_c('v-go-back-btn')], 1)])
},staticRenderFns: []}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-box"
  }, [_c('VNavigator', {
    attrs: {
      "title": "关于我们"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "tab-box"
  }, [_c('li', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.setIndex,
        index: 0
      }),
      expression: "{methods:setIndex, index:0}"
    }],
    staticClass: "tab",
    class: {
      tab_select: _vm.index === 0
    }
  }, [_vm._v("\n        企业介绍\n      ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.setIndex,
        index: 1
      }),
      expression: "{methods:setIndex, index:1}"
    }],
    staticClass: "tab",
    class: {
      tab_select: _vm.index === 1
    }
  }, [_vm._v("\n        品牌故事\n      ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.setIndex,
        index: 2
      }),
      expression: "{methods:setIndex, index:2}"
    }],
    staticClass: "tab",
    class: {
      tab_select: _vm.index === 2
    }
  }, [_vm._v("\n        教育理念\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index === 0),
      expression: "index === 0"
    }],
    staticClass: "company"
  }, [_c('p', [_vm._v("\n          瓦酷机器人是致力于3-13岁青少年的科技教育，让孩子们在“玩中学”，动手拼插 共享创新实践过程,\n          体会抽象的理论知识应用在真实的生活中。从而实现拓展思维和提升生存能力。瓦酷机器人给中国的孩子们带来最特别的教育！")]), _vm._v(" "), _c('p', [_vm._v("\n          瓦酷机器人全部应用丹麦的乐高教具。乐高的专利积木产品种类超过2000种、对产品质量要求非常高：模具公差2微米、软硬适度、超过世界上最严格的卫生标准、拼插2万次不松脱。瓦酷机器人相信通过知识延伸，构建思维和21世纪技能的培养，能够让学生积极思考、团队合作，成为终身学习者。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          瓦酷教育学习方案根据不同年龄(3-13岁)特点设计，涉及学科内容包括科学、技术、数学、设计、社会学等，既适用于课堂教学，也可以作为课外活动和技能培训内容。瓦酷机器人将“快乐教学，创意教学”融入企业文化中。是全国机器人教育中发展最快，教育理念最优的教育基地。\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index === 1),
      expression: "index === 1"
    }],
    staticClass: "brand"
  }, [_c('p', [_vm._v("\n          2012年，在北京东燕郊开发区开创了首家机器人培训机构，开始了我们机器人行业的探索之旅。经过4年的摸索、积累、沉淀，有了今天大家看到的瓦酷机器人创客空间的诞生。")]), _vm._v(" "), _c('p', [_vm._v("瓦酷，这个来自北京新区的企业，正向世人健步走来。她像一匹骏马，气贯长虹；她像一头劲牛，势不可挡；她像一只雄鹰，志在苍穹。四年卓绝历程，瓦酷从微不足道的加盟企业成长为志在创造机器人行业企业老大的新型品牌。")]), _vm._v(" "), _c('P', [_vm._v("\n          四年多的风风雨雨，四年多的春华秋实，瓦酷既有过创业时期的艰苦拓荒，也有过辉煌时刻的万丈豪情；既有过十字路口的彷徨抉择，也有过康庄道上的豪迈奔腾。如今，瓦酷的销售业绩稳居同行业第一，战略扩张稳步推进，市场份额遥遥领先，品牌价值不可小觑，终将成为名副其实的中国机器人培训第一品牌！")]), _vm._v(" "), _c('p', [_vm._v("\n          在新的发展阶段，瓦酷居安思危，主动求变，酝酿更高起点上的再次腾飞。文化，作为推动瓦酷前进的强大动力，也将适应环境与战略的需要，进行科学更新和发展。新时期瓦酷文化突出创新求变、超越进取的时代精神，对内凝聚人心、统一行为，对外树立形象、铸造品牌，最终使瓦酷得以永续发展，永葆基业长青。")]), _vm._v(" "), _c('p', [_vm._v("\n          在经验提炼和理念整合的基础上，瓦酷以理性和实战为基点，制订出这套文化大纲。大纲以“创新、进取、高效、自我超越”为主基调，保持瓦酷绩效导向的文化特征，牢固树立精确管理理念，融入了充满活力的新的文化因素，具有鲜明的时代特征。大纲明确了瓦酷的愿景、使命、价值观念、企业风格、战略思想、管理理念和行为理念；是瓦酷人的行动指针，是统领瓦酷各项政策、制度、规范的基础法则。每个瓦酷人都要思悟其中，行尊于思。")]), _vm._v(" "), _c('p', [_vm._v("从战略的高度上看，文化描绘企业宏图，文化指引企业航向；从发展的现实需求上看，文化激活心智模式，文化凝聚企业力量。而从最根本的意义上讲，文化铸就企业品格，文化赋予企业灵魂！\n        ")]), _c('p', [_vm._v("瓦酷（WAKOO） 延伸机器人瓦力的形象。瓦酷，快乐教学是我们的宗旨。瓦酷，将创新进行到底！")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index === 2),
      expression: "index === 2"
    }],
    staticClass: "theory"
  }, [_vm._m(0)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('p', [_vm._v("\n            瓦酷机器人融合了“玩中学，做中学”的理论基础。并倒入了最新概念的创客意识，让孩子们再学习课程本身的同时，提升创客意识。课程的研发遵循“快乐教学，创意教学”的宗旨，旨在让孩子们“学习科技，探究科技，创新科技”为未来的学习生涯奠定坚实的基础。")]), _vm._v(" "), _c('p', [_vm._v("\n            构主义是我国当前课程改革的学习理论基础之一，是二十多年来在西方教育界流行的一股教育理论思潮，被人们称为教育上的一场“革命”。新创客机器人教育项目以建构主义作为理论基础之一，与我国课程改革方向一致，符合世界课程改革的潮流。")]), _vm._v(" "), _c('p', [_vm._v("\n            认为知识既不是客观的东西也不是主观的东西，而是个体与环境交互作用的过程逐渐构建的结果。学习是一种能动建构的过程，学习并不是个体获得越来越多外部信息的过程，而是学到越来越多的有关他们认识事物的程序即建构了新的认知方式。孩子们在解决问题时，如果能将知识同化到他已有的认知方式中，知识才不会被遗忘。")]), _vm._v(" "), _c('p', [_vm._v("\n            当孩子参与了一件自己有能力解决但是又相对具有一定挑战性任务（不难也不易）的时候，他们将全身心的投入，并具有相当的自信。新创客机器人的每一节课程的难易程度都与之符合，充分增强孩子的自信心，从而让孩子具有积极面对挫折的心态和解决问题的决心。")]), _vm._v(" "), _c('p', [_vm._v("\n            八十年代，美国着名发展心理学家、哈佛大学教授霍华德加德纳博士提出多元智能理论，二十多年来该理论已经广泛应用于欧美国家和亚洲许多国家的教育上，并且获得了极大的成功。霍华德加德纳博士指出，人类的智能是多元化而非单一的，主要是由语言智能、数学逻辑智能、空间智能、身体运动智能、音乐智能、人际智能、自我认知智能、自然认知智能等组成，每个人都拥有不同的智能优势组合。")])])
}]}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "我的消息"
    }
  })], 1), _vm._v(" "), (_vm.myNew.length) ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.myNew), function(obj, index) {
    return _c('VMyNew', {
      key: index,
      attrs: {
        "obj": obj
      }
    })
  }), 1) : _c('div', {
    staticClass: "nothing"
  }, [_vm._v("\n    您还没有消息哦\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrapper"
  }, [_c('VGoBackBtn')], 1)])
},staticRenderFns: []}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-wrapper"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.handleSchoolClick
      }),
      expression: "{methods:handleSchoolClick}"
    }],
    staticClass: "school"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.school.campusName)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "school_tri",
    class: {
      add: _vm.isSelectSchool
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelectSchool),
      expression: "isSelectSchool"
    }]
  }, _vm._l((_vm.schools), function(school, index) {
    return _c('li', {
      directives: [{
        name: "tap",
        rawName: "v-tap",
        value: ({
          methods: _vm.setSchool,
          school: school
        }),
        expression: "{methods:setSchool,school:school}"
      }],
      key: index,
      domProps: {
        "textContent": _vm._s(school.campusName)
      }
    })
  }), 0)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.handleGradeClick
      }),
      expression: "{methods:handleGradeClick}"
    }],
    staticClass: "grade"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.grade.gradeName)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "grade_tri",
    class: {
      add: _vm.isSelectGrade
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelectGrade),
      expression: "isSelectGrade"
    }]
  }, _vm._l((_vm.grades), function(grade, index) {
    return _c('li', {
      directives: [{
        name: "tap",
        rawName: "v-tap",
        value: ({
          methods: _vm.setGrade,
          grade: grade
        }),
        expression: "{methods:setGrade,grade:grade}"
      }],
      key: index,
      domProps: {
        "textContent": _vm._s(grade.gradeName)
      }
    })
  }), 0)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "avator"
  }, [_c('div', {
    staticClass: "icon",
    attrs: {
      "id": "container"
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.icon,
      "id": "pickfiles"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": "/record/setting"
    }
  }, [_c('div', {
    staticClass: "setting"
  })]), _vm._v(" "), _c('div', {
    staticClass: "heart"
  }), _vm._v(" "), _c('div', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "other",
    domProps: {
      "textContent": _vm._s(_vm.other)
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "showcell"
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.typeIcon === 'A') ? _c('div', [_c('div', {
    staticClass: "icon1"
  })]) : (_vm.typeIcon === 'B') ? _c('div', [_c('div', {
    staticClass: "icon2"
  })]) : (_vm.typeIcon === 'C') ? _c('div', [_c('div', {
    staticClass: "icon3"
  })]) : (_vm.typeIcon === 'D') ? _c('div', [_c('div', {
    staticClass: "icon4"
  })]) : _c('div', [_c('div', {
    staticClass: "icon5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.typeIcon === 'B') ? _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.jump
      }),
      expression: "{methods:jump}"
    }]
  }, [_c('div', {
    staticClass: "jump"
  })]) : _vm._e(), _vm._v(" "), (_vm.typeIcon === 'C') ? _c('div', [_c('router-link', {
    attrs: {
      "to": "/record-aboutCourse"
    }
  }, [_c('div', {
    staticClass: "jump"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.typeIcon === 'D') ? _c('div', [_c('router-link', {
    attrs: {
      "to": "/record-completedCourse"
    }
  }, [_c('div', {
    staticClass: "jump"
  })])], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash-box"
  }, [_c('div', {
    staticClass: "logo_box"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(696)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "gear_big"
  }), _vm._v(" "), _c('i', {
    staticClass: "gear_small"
  })])])
}]}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggle
      }),
      expression: "{methods:toggle}"
    }],
    staticClass: "course"
  }, [_c('span', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "course-info"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.course.course_title))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.course.created_at))])]), _vm._v(" "), _c('span', {
    staticClass: "absence"
  }, [_vm._v("缺勤" + _vm._s(_vm.course.absenteeism_count) + "人")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "users"
  }, [_c('ul', _vm._l((_vm.course.absence_user), function(user) {
    return _c('li', {
      key: user.id
    }, [_vm._v("\n        " + _vm._s(user.username) + "\n      ")])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('img', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.close
      }),
      expression: "{methods:close}"
    }],
    style: (_vm.styleObj),
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.handlePre
      }),
      expression: "{methods:handlePre}"
    }],
    staticClass: "left"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.handleNext
      }),
      expression: "{methods:handleNext}"
    }],
    staticClass: "right"
  })])
},staticRenderFns: []}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "已上课程"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "contentchild",
    attrs: {
      "infinite-scroll-disabled": "disable",
      "infinite-scroll-distance": "10"
    }
  }, [_vm._l((_vm.arrayData), function(obj, index) {
    return _c('VCoureseShowCell', {
      key: index,
      attrs: {
        "obj": obj
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingState != 1),
      expression: "loadingState != 1"
    }],
    staticClass: "bottom"
  }, [_c('mt-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingState == 2),
      expression: "loadingState == 2"
    }],
    attrs: {
      "type": "fading-circle",
      "color": "#cba164"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.stateText)
    }
  })], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "goBack"
  }, [_c('VGoBackBtn')], 1)])
},staticRenderFns: []}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer-wrapper"
  }, [_c('div', {
    staticClass: "inner-wrapper"
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-box"
  }, [_c('span', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.itemName)
    }
  }), _vm._v("：\n  "), _c('span', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.itemContent)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "课程相关"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "head"
  }), _vm._v(" "), _c('div', {
    staticClass: "content1"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(this.result.courseSummary)
    }
  })])])]), _vm._v(" "), _c('div', [_c('VGoBackBtn')], 1)])
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('worker-filter', {
    staticStyle: {
      "z-index": "100"
    },
    on: {
      "gradeSelect": _vm.getAllStudents
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stu-list"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('v-title', {
    attrs: {
      "page-title": "签到记录"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.studentList.length > 0) ? _c('div', {
    staticClass: "selectList"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCourse),
      expression: "selectedCourse"
    }],
    staticClass: "selectStyle",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCourse = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.studentList), function(item) {
    return _c('option', {
      key: item.course_title,
      domProps: {
        "value": item.course_title
      }
    }, [_vm._v("\n                  " + _vm._s(item.course_title) + "\n                ")])
  }), 0), _vm._v(" "), _c('ul', _vm._l((_vm.filteredStudents), function(student, index) {
    return _c('li', {
      key: student.userId
    }, [_c('card-view', [_c('check-in-item', {
      attrs: {
        "slot": "content",
        "student": student,
        "userImage": student.userImage.length,
        "reasons": _vm.reasons,
        "position": index
      },
      on: {
        "itemChecked": _vm.itemChecked
      },
      slot: "content"
    })], 1)], 1)
  }), 0)]) : _c('div', {
    staticClass: "no-students"
  }, [_vm._v("\n              暂无签到内容\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.back
      }),
      expression: "{methods:back}"
    }],
    staticClass: "back"
  }, [_vm._v("\n          返回\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.submit
      }),
      expression: "{methods:submit}"
    }],
    staticClass: "submit"
  }, [_vm._v("\n          提交\n        ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/record-completedCourse-detail',
        query: {
          id: _vm.obj.id
        }
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "des",
    domProps: {
      "textContent": _vm._s(_vm.obj.courseId)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "des1",
    domProps: {
      "textContent": _vm._s(_vm.obj.createTime + '>')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "green-bg"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageTitle))])])
},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('worker-filter'), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/student-check-in"
    }
  }, [_c('button', {
    staticClass: "base-btn qiandao",
    on: {
      "click": _vm.selectSign
    }
  }, [_vm._v("\n      签 到\n    ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/student-list"
    }
  }, [_c('button', {
    staticClass: "base-btn huamingce"
  }, [_vm._v("\n      学员花名册\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-item"
  }, [_c('div', [_c('div', {
    staticClass: "flex-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.createTimes))]), _vm._v(" "), _c('p', {
    staticClass: "textnum"
  }, [_vm._v(_vm._s(_vm.item.classId))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/signature/" + (_vm.item.id) + "/" + (_vm.item.signStatus) + "/false")
    }
  }, [(_vm.item.signStatus == '1') ? [_c('span', {
    on: {
      "click": function($event) {
        return _vm.look(_vm.item.id, _vm.item.signStatus, _vm.item.status, _vm.item.createTimes)
      }
    }
  }, [_vm._v("查看>")])] : [_c('span', {
    staticStyle: {
      "color": "#13ce66"
    },
    on: {
      "click": function($event) {
        return _vm.look(_vm.item.id, _vm.item.signStatus, _vm.item.status, _vm.item.createTimes)
      }
    }
  }, [_vm._v("签字>")])]], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('worker-filter', {
    staticStyle: {
      "z-index": "100"
    },
    on: {
      "gradeSelect": _vm.getAttendanceList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "attendance"
  }, [_c('div', {
    staticClass: "list"
  }, [(_vm.courseList.length > 0) ? _c('ul', _vm._l((_vm.courseList), function(course, index) {
    return _c('li', {
      key: index
    }, [_c('attendance-item', {
      attrs: {
        "course": course
      }
    })], 1)
  }), 0) : _c('p', [_vm._v(" 没有数据 ")])])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "back-box"
  }, [_c('v-go-back-btn')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('span', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.goback
      }),
      expression: "{methods:goback}"
    }],
    staticClass: "back"
  }), _vm._v(" "), _c('span', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('peopleHeader')], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "aboutCourse"
  }, [_c('VShowCell', {
    attrs: {
      "typeIcon": "C",
      "title": "课程相关"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "completeCourse"
  }, [_c('VShowCell', {
    attrs: {
      "typeIcon": "D",
      "title": "已上课程"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "selectParent"
  }, [_c('div', {
    staticClass: "selectitem1"
  }, [_c('router-link', {
    attrs: {
      "to": "/class",
      "active-class": "u-link--Active1"
    }
  }, [_c('div', {
    staticClass: "select1"
  }, [_vm._v("课时核对")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "selectitem2"
  }, [_c('router-link', {
    attrs: {
      "to": "/record",
      "active-class": "u-link--Active2"
    }
  }, [_c('div', {
    staticClass: "select1"
  }, [_vm._v("我的档案")])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "time",
    domProps: {
      "textContent": _vm._s(_vm.obj.created_at)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    domProps: {
      "textContent": _vm._s(_vm.obj.message)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "我的照片"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "scroll",
    staticClass: "photo"
  }, [_c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "photosInfo.disable",
      "infinite-scroll-immediate-check": "false",
      "infinite-scroll-distance": "50"
    }
  }, [_c('li', _vm._l((_vm.photosInfo.photos), function(obj, index) {
    return _c('img', {
      directives: [{
        name: "tap",
        rawName: "v-tap",
        value: ({
          methods: _vm.click,
          index: index
        }),
        expression: "{methods:click,index:index}"
      }],
      staticClass: "photodetail",
      attrs: {
        "src": obj.image_shrinkage,
        "alt": ""
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.photosInfo.loadingState != 1),
      expression: "photosInfo.loadingState != 1"
    }],
    staticClass: "bottom"
  }, [_c('mt-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.photosInfo.loadingState == 2),
      expression: "photosInfo.loadingState == 2"
    }],
    attrs: {
      "type": "fading-circle",
      "color": "#cba164"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.loadingText)
    }
  })], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', [_c('VGoBackBtn', {
    on: {
      "exit": _vm.exit
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "class-wrapper"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "class-bg"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('v-title', {
    staticClass: "title",
    attrs: {
      "page-title": "我的课时"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "release-wrapper"
  }, [_c('el-date-picker', {
    staticClass: "narrow-datepicker",
    attrs: {
      "size": "mini",
      "type": "year",
      "placeholder": "选择年",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), (_vm.isCustom) ? [_c('router-link', {
    attrs: {
      "to": "/signature/0/0/true"
    }
  }, [_c('div', {
    staticClass: "publish",
    on: {
      "click": _vm.historyClass
    }
  }, [_c('span', [_vm._v("历史课时>>")])])])] : _vm._e()], 2), _vm._v(" "), _c('mt-loadmore', {
    ref: "refresh",
    attrs: {
      "id": "scroll-wrapper",
      "top-method": _vm.refresh
    }
  }, [_c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "list-wrapper",
    attrs: {
      "infinite-scroll-disabled": "disable",
      "infinite-scroll-distance": "10"
    }
  }, _vm._l((_vm.newsList), function(item) {
    return _c('news-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingState != 1),
      expression: "loadingState != 1"
    }],
    staticClass: "bottom"
  }, [_c('mt-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingState == 2),
      expression: "loadingState == 2"
    }],
    attrs: {
      "type": "fading-circle",
      "color": "#cba164"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.stateText)
    }
  })], 1)])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-bg"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "btn-wrapper"
  }, [_c('blue-btn', {
    attrs: {
      "info": "返回",
      "handle-click": _vm.cancel
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "desc-block img-block"
  }, [_c('p', [_vm._v("课程签到")]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('card-view', [_c('div', {
    staticClass: "faBox",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.$route.params.signStatus == '0') ? [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "10px"
    },
    attrs: {
      "src": _vm.bgPic
    },
    on: {
      "click": _vm.showPreview
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textQian"
  }, [_c('span', [_vm._v("签字后>>")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "10px"
    },
    attrs: {
      "src": _vm.makePic
    },
    on: {
      "click": _vm.showPreview1
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "boxEsign"
  }, [_c('vue-esign', {
    ref: "esign",
    staticStyle: {
      "border": "1px solid black",
      "margin-top": "5px",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "isCrop": _vm.isCrop,
      "lineWidth": _vm.lineWidth,
      "lineColor": _vm.lineColor,
      "bgColor": _vm.bgColor
    },
    on: {
      "update:bgColor": function($event) {
        _vm.bgColor = $event
      },
      "update:bg-color": function($event) {
        _vm.bgColor = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("清空画板")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.drawProdPicture
    }
  }, [_vm._v("完成签字")])], 1)] : [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "10px"
    },
    attrs: {
      "src": _vm.makePic
    },
    on: {
      "click": _vm.showPreview1
    }
  })]], 2)]), _vm._v(" "), (_vm.$route.params.signStatus == '0') ? [_c('div', {
    staticClass: "btn-wrapper2"
  }, [_c('blue-btn', {
    attrs: {
      "info": "提交",
      "handle-click": _vm.submit
    }
  })], 1)] : _vm._e()], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "username"
  }, [_c('i', {
    staticClass: "icon mobile-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mobile),
      expression: "mobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "title": "username",
      "id": "mobile",
      "type": "text",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "blur": [_vm.validatePhoneNumber, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), (!_vm.isValidPhoneNumber && _vm.isBlured) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.phoneErrorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pwd"
  }, [_c('i', {
    staticClass: "icon pwd-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "title": "password",
      "id": "password",
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.handleRememberClick
      }),
      expression: "{methods:handleRememberClick}"
    }],
    staticClass: "remember",
    class: {
      no_remember_me: !_vm.isRemember,
      remember_me: _vm.isRemember
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.login
      }),
      expression: "{methods:login}"
    }],
    staticClass: "login-btn"
  })])
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parentDetail"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "已上课程"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "contentdetail"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "nameIcon"
  }), _vm._v(" "), _c('div', {
    staticClass: "nameContent",
    domProps: {
      "textContent": _vm._s(_vm.obj.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goalIcon"
  }), _vm._v(" "), _c('div', {
    staticClass: "goalContent",
    domProps: {
      "textContent": _vm._s(_vm.obj.teachingObjectives)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "passIcon"
  }), _vm._v(" "), _c('div', {
    staticClass: "passContent",
    domProps: {
      "textContent": _vm._s(_vm.obj.teachingProcess)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photoIcon"
  }), _vm._v(" "), _c('div', {
    staticClass: "photoContent"
  }, _vm._l((_vm.obj.imageUrl), function(object, index) {
    return _c('img', {
      directives: [{
        name: "tap",
        rawName: "v-tap",
        value: ({
          methods: _vm.handleClick,
          index: index
        }),
        expression: "{methods:handleClick,index:index}"
      }],
      key: index,
      staticClass: "photodetail",
      attrs: {
        "src": object,
        "alt": ""
      }
    })
  }), 0)])]), _vm._v(" "), _c('div', [_c('VGoBackBtn')], 1)])
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-bg"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "btn-wrapper"
  }, [_c('blue-btn', {
    attrs: {
      "info": "返回",
      "handle-click": _vm.cancel
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "desc-block img-block"
  }, [_c('p', [_vm._v("班级出勤人数图片")]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "overflow"
  }, [_c('card-view', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.url,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList,
      "on-change": _vm.handleChange,
      "accept": '.jpg,.jpeg,.png,.bmp',
      "headers": _vm.headers,
      "multiple": "",
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper2"
  }, [_c('blue-btn', {
    attrs: {
      "info": "提交",
      "handle-click": _vm.submits
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */
/***/ (function(module, exports) {

module.exports = Qiniu;

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = plupload;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 808 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 809 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 810 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[348]);


// WEBPACK FOOTER //
// static/js/app.756a9d85287273bd002b.js